import React, {
  startTransition,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import {
  Container,
  Modal,
  Table,
  Button,
  Spinner,
  Form,
} from "react-bootstrap";
import {
  Modal as AntdModal,
  Button as AntdButton,
  Space,
  Typography,
  message,
} from "antd";
import {
  TextField,
  Checkbox,
  InputAdornment,
  TextareaAutosize,
} from "@material-ui/core";

import { NavLink } from "react-router-dom";
import modalimg from "../image/itemnotfound.png";
import scanimg from "../image/barcodescan.png";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import DehazeIcon from "@material-ui/icons/Dehaze";
import CancelIcon from "@material-ui/icons/Cancel";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { v4 as uuidv4 } from "uuid";
import config, { mobileNumberLimit } from "../../config";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import { Loyalty } from "@mui/icons-material";
import { camelCase, startCase } from "lodash";
import ReactToPrint from "react-to-print";
import { useDebounce } from "../../hooks/useDebounce";
import { a4BillTemplate } from "./A4Billtemplate";
import { FiChevronRight } from "react-icons/fi";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import DoubleArrow from "../../assets/icons/Vector.svg";
import UPISVG from "../../assets/icons/UPISVG.svg";
import { MdAddCircleOutline } from "react-icons/md";
import { AiOutlineMinusCircle } from "react-icons/ai";
import { RiCloseCircleLine } from "react-icons/ri";
import { MdOutlineClose } from "react-icons/md";
import { BsCash } from "react-icons/bs";
import { BsCreditCard2Back } from "react-icons/bs";
import { Divider } from "antd";
// import { Steps, Hints } from "intro.js-react";
// import "intro.js/introjs.css";
import StartCounterModal from "../cash-counter/start-counter-modal";
import InvoiceTemplate from "./InvoiceTemplate";
import Invoice from "../Invoice/Invoice";
import usePageVisibility from "../../hooks/usePageVisibility";
import { getProductDetails, getShopDetails } from "../../service/service";
import useOnClickOutside from "../../hooks/useOutsideClick";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import moment from "moment";

var INITIAL_INPUT_STATE = {
  itemName: "",
  itemRate: "",
  itemQuantity: "",
  itemMRP: "",
  itemDiscount: "",
  itemWastage: "",
  itemLabour: "",
  itemHsnCode: "",
  itemLevelTax: "",
  itemTaxType: "",
  itemPurchasePrice: "",
  measurmentValue: "",
  measurmentUnit: "",
  productTax: "",
  productTaxType: "",
  taxIncExc: "",
  unitOfMeasurment: "",
  itemEANCode: "",
  imei1: "",
  imei2: "",
  taxId: "",
  billDiscount: 0,
  billTax: 0,
  billLoyaltyDiscount: 0,
  billCoupon: 0,
  billPrepaid: 0,
  billPaidAmount: "",
  billDue: 0,
};
var INITIAL_RESULT_STATE = {
  itemSubTotal: 0,
  itemTotalAfterDiscount: 0,
  itemTotalAfterWastage: 0,
  itemTotalAfterLabour: 0,
  itemTotalAfterTax: 0,
  billTotalBeforeTax: 0,
  billTotalAfterTax: 0,
  billTotalAfterCharges: 0,
  billTotalAfterLoyalty: 0,
  billTotalAfterCoupon: 0,
  billFinalTotal: 0,
  billAmountDue: 0,
  billPaidAmount: 0,
  roundOffAmount: 0,
  invoiceNumber: "",
  couponDiscountAmount: 0,
};
var INITIAL_DISCOUNT_TYPE_STATE = {
  itemDiscountType: "",
  billDiscountType: "flat",
  loyaltyDiscountType: "",
  couponDiscountType: "",
};

const UNIT = [
  "g",
  "kg",
  "mg",
  "ml",
  "L",
  "cup",
  "count",
  "box",
  "pkt",
  "glass",
  "cm",
  "m",
  "km",
  "min",
  "hour",
  "days",
  "inch",
  "Ton",
];

const Billing = (props) => {
  const alertMsg = useRef();
  const closeTotal = useRef();
  const totalButton = useRef();
  const shopDetails = useSelector((state) => state.shopDetails);
  // const consoler = () => {
  //   var x = document.cookie;
  // };
  useOnClickOutside(closeTotal, () => totalButton.current.click());
  const { uniqueIdentity: identifier = false, ...invoiceSettings } =
    useSelector((state) => state.newInvoicesettings.newInvoicesettings);
  const [CustomerFoundFrom, setCustomerFoundFrom] = useState();
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const settings = useSelector((state) => state.settings.settings);
  const draftedBills = useSelector((state) => state.shopDetails.draftBill);
  const checkBill = useSelector((state) => state.shopDetails.checkBill);
  const dispatch = useDispatch();
  const printRef = React.useRef();
  const confirmRef = useRef();
  const customTaxType = useSelector((state) => state.shopDetails.customTaxType);
  const [starterCounterModal, setStarterCounterModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [customerDetailsLoading, setCustomerDetailsLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [counterId, setCounterId] = useState("");
  const isVisible = usePageVisibility();
  const [uniqueId, setUniqueId] = useState("");
  const [isSms, setIsSms] = useState(false);

  const [billLineSettings, setBillLineSettings] = useState({
    hasBlockNo: false,
    hasDeliveryAddress: false,
    discount: false,
    tax: false,
    taxMaster: [],
    reedemPoints: false,
    roundOff: false,
    paidAmount: false,
    prepaidAmount: false,
    otherCharges: false,
    coupon: false,
    imei: false,
    itemMRP: false,
    itemDiscount: false,
    itemWastage: false,
    itemLabour: false,
    hsnCode: false,
    itemLevelTax: false,
    billingAddress: false,
    shippingAddress: false,
    termsAndCondition: false,
    paymentTerms: false,
    dueDate: false,
    invoicePrefix: false,
    employee: false,
    modeOfPayment: false,
    addRemainder: false,
    tAndCField: "",
    paymentTermsField: "",
    invoicePrefixField: "",
    invoiceSuffixField: 2022001,
    currentInvoiceNumber: 2022001,
    otherChargesField: [],
    printerType: "Thermal",
    invoiceTemplate: "template1",
    thermalPaperSize: "55",
  });

  const [addedProducts, setAddedProducts] = useState([]);
  const [settingModal, setSettingModal] = useState(false);

  const [invoicePage, setinvoicePage] = useState(false);
  // const [generateBillModal, setGeneateBillModal] = useState(false);
  const [itemBillInput, setItemBillInput] = useState(INITIAL_INPUT_STATE);
  const [itemBillResult, setItemBillResult] = useState(INITIAL_RESULT_STATE);
  const [discountType, setDiscountType] = useState(INITIAL_DISCOUNT_TYPE_STATE);
  ///
  const [addExtraChargeField, setAddExtraChargeField] = useState(false);
  const [chargesName, setChargesName] = useState("");
  ///
  const [addTermsField, setaddTermsField] = useState(false);
  ///
  const [addPaymentTermsField, setAddPaymentTermsField] = useState(false);
  ///
  const [addInvoicePrefixField, setAddInvoicePrefixField] = useState(false);
  ///
  const [productArray, setProductArray] = useState([]);
  const [customerPhoneNumber, setCustomerPhoneNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  // const [employeeArr, setEmployeeArr] = useState([]);
  const [employee, setEmployee] = useState("");
  const [addressCheckBox, setAddressCheckBox] = useState(false);
  const [billShipAddress, setBillShipAddress] = useState({
    billingAddress: "",
    shippingAddress: "",
  });
  const [isAdvanceSetting, setIsAdvanceSetting] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState([]);
  // const [paymentSelect, setPaymentSelect] = useState({
  //   selectUpi: false,
  //   selectCard: false,
  //   selectCash: false,
  // });
  // const [smsOnlyLoading, setSmsOnlyLoading] = useState(false);
  // const [smsPdfLoading, setSmsPdfLoading] = useState(false);
  const [dueDate, setDueDate] = useState("");
  // const [pdfPrinting, setPdfPrinting] = useState(false);
  const [productCode, setProductCode] = useState("");
  // const [paymentSelect, setPaymentSelect] = useState({
  // const [prodArr, setProdArr] = useState([]);
  ///
  const currencyFormatter = useCurrency();
  const country = useCountry();
  const [toggleState, setToggleState] = useState(1);
  const [otherCharges, setotherCharges] = useState(false);
  const [currentDraft, setCurrentDraft] = useState(true);
  const [addNewItem, setAddNewItem] = useState(false);
  const [showShortkeys, setShowShortkeys] = useState(false);
  const [deliveryAddr, setDeliveryAddr] = useState(false);
  const [notesModal, setNotesModal] = useState(false);
  const [itemNotFound, setItemNotFound] = useState(false);
  const [billConfirm, setBillConfirm] = useState(false);
  const [billDraft, setBillDraft] = useState([]);
  const [offersModal, setOffersModal] = useState(false);
  const [couponArr, setCouponArr] = useState([]);
  const [couponArrDefault, setCouponArrDefault] = useState([]);
  const [promoCode, setPromoCode] = useState("");
  const [notes, setNotes] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState({});
  const [loyaltyArr, setLoyaltyArr] = useState([]);
  const [loyaltyPoints, setLoyaltyPoints] = useState(0);
  const [outStanding, setOutStanding] = useState(0);
  const [loyaltyModal, setLoyaltyModal] = useState(false);
  const [appliedLoyalty, setAppliedLoyalty] = useState({});
  const [billLoading, setBillLoading] = useState(false);
  const [cardType, setCardType] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [taxList, setTaxList] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [billPrint, setBillPrint] = useState(false);
  const isTax = invoiceSettings.itemleveltax || false;
  const [creditSale, setCreditSale] = useState(false);
  const [amountPaidUsingCash, setAmountPaidUsingCash] = useState("");
  const [amountPaidUsingCard, setAmountPaidUsingCard] = useState("");
  const [amountPaidUsingUpi, setAmountPaidUsingUpi] = useState("");
  // const [upiServiceType, setUpiServiceType] = useState("");
  const [paymentMethodForThermal, setPaymentMethodForThermal] = useState([]);
  // const [walletAmount,setwalletAmount] = useState("")
  const productsForSearch = useSelector((state) => state.productsForSearch);
  const { productList: products } = useSelector((state) => state.products);
  const [otherBillDetailsModal, setOtherBillDetailsModal] = useState(false);
  const debouncedSearchEanCode = useDebounce(productCode, 500);
  const [otherChargesModal, setOtherChargesModal] = useState(false);
  const [summedOtherCharges, setSummedOtherCharges] = useState("0.00");
  //Enables and disables bill or line additional settings
  const cutomerNumberRef = useRef();
  const checkBoxHandler = (event) => {
    setBillLineSettings({
      ...billLineSettings,
      [event.target.value]: event.target.checked,
    });
    if (event.target.value == "discount") {
      setItemBillInput({
        ...itemBillInput,
        billDiscount: 0,
      });
    }
    if (event.target.value == "otherCharges") {
      setBillLineSettings((prev) => ({
        ...prev,
        otherChargesField: [
          ...billLineSettings.otherChargesField.map((arrData) => {
            return {
              ...arrData,
              price: "",
            };
          }),
        ],
      }));
      setSummedOtherCharges("0.00");
    }
  };

  console.log("currencyFormatter", currencyFormatter(10));

  const handleInputChange = (event) => {
    setItemBillInput({
      ...itemBillInput,
      [event.target.name]: event.target.value,
    });
  };

  useEffect(() => {
    var paidUsingCash = parseFloat(amountPaidUsingCash)
      ? parseFloat(amountPaidUsingCash)
      : parseFloat(0);
    var paidUsingCard = parseFloat(amountPaidUsingCard)
      ? parseFloat(amountPaidUsingCard)
      : parseFloat(0);
    var paidUsingUpi = parseFloat(amountPaidUsingUpi)
      ? parseFloat(amountPaidUsingUpi)
      : parseFloat(0);
    var totalAmount = paidUsingCash + paidUsingCard + paidUsingUpi;
    setItemBillResult((prev) => ({
      ...prev,
      billAmountDue: parseFloat(prev.billFinalTotal) - totalAmount,
      billPaidAmount: totalAmount,
    }));
  }, [
    amountPaidUsingCard,
    amountPaidUsingCash,
    amountPaidUsingUpi,
    itemBillResult.billFinalTotal,
  ]);

  useEffect(() => {
    if (shopDetails.shopType !== "Restaurant") {
      if (shopDetails.shopId) {
        fetch(`${config.newApiGateway}/bill/customBillsettings`, {
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ shopId: shopDetails.shopId, type: "update" }),
          method: "POST",
        })
          .then((res) => res.json())
          .then((data) => {
            console.log("settings data=====", data);
            // const Check boxdata= JSON.parse(data)
            console.log("Checkboxdata------", data);
            let Checkboxdata = data.newBillsettings;
            let UpdateCheckbox = {};
            for (let i = 0; i < Checkboxdata.length; i++) {
              Object.assign(UpdateCheckbox, Checkboxdata[i]);
            }

            console.log(
              "\nAfter converting  Billing_______----",
              UpdateCheckbox
            );
            dispatch({
              type: "INVOICE-NEWBILLSETTINGS",
              payload: UpdateCheckbox,
            });

            return Checkboxdata;
          });
      }
    }
  }, [shopDetails.shopId]);

  useEffect(() => {
    if (itemBillResult.billAmountDue <= 0) {
      setItemBillResult((prev) => ({
        ...prev,
        walletAmount: Math.abs(itemBillResult.billAmountDue),
      }));
    }
  }, [itemBillResult.billAmountDue]);
  const formValidation = (product, from) => {
    if (itemBillInput.taxId && itemBillInput.taxIncExc === "") {
      return alert("Please select a inclusive or exclusive");
    }
    dispatch({
      type: "SET_PRODUCT_LIST",
      payload: [...products, product],
    });
    dispatch({
      type: "SET_PRODUCTS_SEARCH",
      payload: [
        ...productsForSearch,
        {
          id: product.productId,
          name: product.productName,
          eanCode: product.productEANCode,
          color: product.color,
        },
      ],
    });
    addItemHandler(product, from);
  };
  // useEffect(() => {
  //   console.log("billLineSettings", billLineSettings);
  // }, [billLineSettings]);
  useEffect(() => {
    console.log("appliedLoyalty", appliedLoyalty);
  }, [appliedLoyalty]);

  const addOtherCharges = () => {
    var charges = 0;
    billLineSettings.otherChargesField.map((data) => {
      if (parseFloat(data.price)) {
        charges += parseFloat(data.price);
      } else {
        charges += 0;
      }
    });
    console.log("chargesss", charges);
    setSummedOtherCharges(charges.toFixed("2"));
  };

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const itemDiscountCalc = (total, discount, discountType) => {
    if (invoiceSettings.itemdiscount) {
      if (discount === "" || !discount) discount = 0;
      if (discountType === "flat") {
        total = parseFloat(total) - parseFloat(discount);
      }
      if (discountType === "percentage") {
        const discountValue = (parseFloat(total) * parseFloat(discount)) / 100;
        total = parseFloat(total) - discountValue;
      }
    }
    return total;
  };

  useEffect(() => {
    (async function () {
      if (isVisible && shopDetails.shopId) {
        setFetchLoading(true);
        const shop_Details = await getShopDetails(shopDetails.shopId);
        const productDetails = await getProductDetails(shopDetails.shopId);
        console.log("shop_Details", shop_Details);
        dispatch({
          type: "SET_SETTINGS",
          payload: shop_Details.settings,
        });
        if (productDetails.products) {
          const addToLocalStroage = productDetails?.products?.map((i) => {
            let label = i.productName;
            if (
              i.unitOfMeasurment !== "Others" &&
              !i.unitOfMeasurment !== true
            ) {
              label += `(${i.unitOfMeasurment})`;
            }
            if (i.size) {
              label += ` Size:${i.size}`;
            }
            return {
              id: i.productId,
              name: label,
              eanCode: i.productEANCode,
              color: i.color,
              productCode: i.productCode,
              value: i.productName.toLowerCase(),
            };
          });
          dispatch({
            type: "SET_PRODUCTS_SEARCH",
            payload: addToLocalStroage,
          });
          dispatch({
            type: "SET_PRODUCT_LIST",
            payload: productDetails.products,
          });
        }
        setFetchLoading(false);
      }
    })();
  }, [isVisible, shopDetails.shopId]);

  console.log("FetchLoading", fetchLoading);

  const taxableValueFunc = (
    productPrice = 0,
    productTax = 0,
    count,
    taxIncExc = "inclusive"
  ) => {
    const isTax = invoiceSettings.itemleveltax || false;
    let result = 0;
    if (isTax) {
      if (taxIncExc === "inclusive") {
        result =
          (parseFloat(productPrice) / (100 + parseFloat(productTax || 0))) *
          parseFloat(count || 0) *
          100;
      } else if (taxIncExc === "exclusive") {
        result = parseFloat(productPrice) * parseFloat(count || 0);
      } else {
        result = parseFloat(productPrice) * parseFloat(count);
      }
    } else {
      result = parseFloat(productPrice) * parseFloat(count);
    }
    return result;
  };

  const taxTypeFunc = (taxableValue, seletedTax) => {
    const isTax = invoiceSettings.itemleveltax || false;
    const customTaxValue = {};
    if (isTax) {
      seletedTax.taxType?.forEach((tax) => {
        const taxTypeName =
          customTaxType.find((customTax) => customTax.taxId === tax)?.taxName ||
          tax;
        customTaxValue[taxTypeName] =
          (customTaxValue[taxTypeName] || 0) +
          parseFloat(
            taxableValue * (parseFloat(seletedTax[taxTypeName] || 0) / 100)
          );
      });
    }
    const sumOfTax = Object.values(customTaxValue).reduce(
      (acc, cur) => acc + cur,
      0
    );
    const itemTotal = parseFloat(taxableValue) + sumOfTax;
    return {
      ...customTaxValue,
      taxType: Object.keys(customTaxValue) ? Object.values(customTaxValue) : [],
      itemTotal,
      taxableValue,
      totalBeforeTax: taxableValue,
    };
  };

  const getTaxableValueAndTaxs = (
    product,
    displayPrice,
    price = 0,
    quantity = 1
  ) => {
    let selectedTax = {};
    let taxableValue = 0;
    let totalTaxPercentage = 0;
    let taxs = {};
    let newProduct = {};
    let itemTotal = 0;
    if (isTax) {
      if (
        product.taxId &&
        product.taxId !== "Select Tax" &&
        product.taxIncExc !== "Inclusive/Exclusive"
      ) {
        selectedTax = taxList.find(
          (data) => data.taxId.toString() === product.taxId.toString()
        );
        totalTaxPercentage = selectedTax.taxType.reduce((acc, curr) => {
          const taxTypeName =
            customTaxType.find((customTax) => customTax.taxId === curr)
              ?.taxName || curr;
          return acc + parseFloat(selectedTax[taxTypeName] || 0);
        }, 0);
        taxableValue = taxableValueFunc(
          price,
          totalTaxPercentage,
          quantity,
          product.taxIncExc
        );
        taxs = taxTypeFunc(taxableValue, selectedTax);
      }
      // else if (["inclusive", "exclusive"].includes(product.taxIncExc)) {
      //   taxableValue = taxableValueFunc(
      //     price,
      //     product.productTax,
      //     quantity,
      //     product.taxIncExc
      //   );
      //   taxs = prevTaxTypeFunc(
      //     taxableValue,
      //     product.productTax,
      //     product.productTaxType
      //   );
      // }
      else {
        itemTotal = parseFloat(price || 0) * parseFloat(quantity || 0);
      }
    } else {
      if (product.hasOwnProperty("gst")) {
        delete product.gst;
      } else if (product.hasOwnProperty("cess")) {
        delete product.cess;
      } else if (product.hasOwnProperty("additionalcess")) {
        delete product.additionalcess;
      } else if (product.hasOwnProperty("igst")) {
        delete product.igst;
      }
      itemTotal = parseFloat(price || 0) * parseFloat(quantity || 0);
    }
    // itemTotal = itemDiscountCalc(
    //   itemTotal + (taxs.itemTotal || 0),
    //   product.discountPrice,
    //   product.discountType,
    //   quantity
    // );
    newProduct = {
      ...product,
      ...taxs,
      productPrice: displayPrice,
      count: quantity,
      totalTax: totalTaxPercentage,
      itemTotal: itemTotal + (taxs.itemTotal || 0),
    };
    return newProduct;
  };

  useEffect(() => {
    var tempArr = [];
    addedProducts.map((data) => {
      var itemTotal = data.productPrice;
      var sellingPrice = data.productPrice;
      var totalBeforeTax = itemTotal;
      let totalTaxPercentage = 0;
      let taxableValue = 0;
      let taxs = {};
      //itemTotal = itemTaxCalc(itemTotal, data.productTax);

      const getUpdatedPrice = itemDiscountCalc(
        data.productPrice,
        data.discountPrice,
        data.discountType
      );
      console.log("getUpdatedPrice", getUpdatedPrice);
      const productObj = getTaxableValueAndTaxs(
        data,
        data.productPrice,
        getUpdatedPrice,
        data.count
      );
      tempArr.push({
        ...productObj,
        totalBeforeTax: totalBeforeTax,
      });
    });

    setAddedProducts([...tempArr]);
  }, [invoiceSettings.itemdiscount, invoiceSettings.itemleveltax]);

  const updateExistingProduct = (productId, _product) => {
    const product = {
      ..._product,
    };
    const isTax = invoiceSettings.itemleveltax || false;
    let taxableValue = 0;
    let taxs = {};
    let seletedTax = {};
    let totalTaxPercentage = 0;
    let itemTotal = 0;
    const count = parseFloat(product.count) + 1;
    let productPrice = product.productPrice;
    if (invoiceSettings.itemdiscount) {
      const discountPricePerQuantity = itemDiscountCalc(
        product.productPrice,
        product.discountPrice,
        product.discountType
      );
      productPrice = discountPricePerQuantity;
    }
    if (isTax) {
      if (product.taxId && product.taxId !== "Select Tax") {
        seletedTax = taxList.find(
          (data) => data.taxId.toString() === product.taxId.toString()
        );
        totalTaxPercentage =
          parseFloat(seletedTax.gst || 0) +
          parseFloat(seletedTax.cess || 0) +
          parseFloat(seletedTax.additionalcess || 0) +
          parseFloat(seletedTax.igst || 0);
        taxableValue = taxableValueFunc(
          productPrice,
          totalTaxPercentage,
          count,
          product.taxIncExc
        );

        taxs = taxTypeFunc(taxableValue, seletedTax);
      } else {
        itemTotal = productPrice * count;
      }
    } else {
      itemTotal = productPrice * count;
    }
    const updateProduct = {
      ...product,
      ...taxs,
      totalTax: totalTaxPercentage,
      taxableValue: taxableValue,
      taxMaster: seletedTax,
      count: count,
      itemTotal: taxs.itemTotal || itemTotal,
    };
    return updateProduct;
  };

  const handleBillingInputChange = (key, value, product, index) => {
    let productObj = {};
    if (key === "count") {
      const getUpdatedPrice = itemDiscountCalc(
        product.productPrice,
        product.discountPrice,
        product.discountType
      );
      const price =
        getUpdatedPrice > 0 ? getUpdatedPrice : product.productPrice;
      console.log("price12", price, getUpdatedPrice, value);
      productObj = getTaxableValueAndTaxs(
        product,
        product.productPrice,
        price,
        value
      );
    } else if (key === "productPrice") {
      const getUpdatedPrice = itemDiscountCalc(
        value,
        product.discountPrice,
        product.discountType
      );
      const price = getUpdatedPrice > 0 ? getUpdatedPrice : value;
      console.log("price12", price, getUpdatedPrice, value);
      productObj = getTaxableValueAndTaxs(product, value, price, product.count);
    }

    let filteredArr = addedProducts.filter(
      (data) => data.productId !== product.productId
    );
    filteredArr = [
      ...filteredArr.slice(0, index),
      productObj,
      ...filteredArr.slice(index),
    ];
    startTransition(() => {
      setAddedProducts([...filteredArr]);
    });
  };

  const setToInitialState = (status) => {
    setProductCode("");
    setItemBillInput({
      ...itemBillInput,
      taxId: "",
      taxIncExc: "",
      itemName: "",
      itemRate: "",
      itemQuantity: "",
      itemMRP: "",
      itemDiscount: "",
      itemWastage: "",
      itemEANCode: "",
      itemPurchasePrice: "",
      itemLabour: "",
      itemHsnCode: "",
      itemLevelTax: "",
      itemTaxType: "",
      imei1: "",
      imei2: "",
      unitOfMeasurment: "",
      measurmentValue: "",
      measurmentUnit: "",
      billDiscount: 0,
      billTax: 0,
      billPaidAmount: "",
    });
    setAddNewItem(false);
    setDiscountType(INITIAL_DISCOUNT_TYPE_STATE);
    if (status === "generated" || status === "hold") {
      setBillLoading(false);
      setLoyaltyPoints(0);
      setPaymentMethod([]);
      setAppliedCoupon({});
      setAppliedLoyalty({});
      setSubTotal(0);
      setItemBillResult({
        ...itemBillResult,
        itemSubTotal: 0,
        walletAmount: 0,
        itemTotalAfterDiscount: 0,
        itemTotalAfterWastage: 0,
        itemTotalAfterLabour: 0,
        itemTotalAfterTax: 0,
        billSubTotal: 0,
        billTotalBeforeTax: 0,
        billTotalAfterTax: 0,
        billTotalAfterCharges: 0,
        billTotalAfterLoyalty: 0,
        billTotalAfterCoupon: 0,
        billFinalTotal: 0,
        billAmountDue: 0,
      });
      if (invoiceSettings.othercharges) {
        if (billLineSettings.otherChargesField.length > 0) {
          setBillLineSettings({
            ...billLineSettings,
            otherChargesField: [
              ...billLineSettings.otherChargesField.map((data) => ({
                ...data,
                price: "",
              })),
            ],
          });
        }
      }
      return;
    }
    setItemBillResult({
      ...itemBillResult,
      itemSubTotal: 0,
      itemTotalAfterDiscount: 0,
      itemTotalAfterWastage: 0,
      itemTotalAfterLabour: 0,
      itemTotalAfterTax: 0,
    });
  };
  //delete items form Array
  const deleteItemHandler = (key) => {
    setAddedProducts((items) => items.filter((data) => data.productId !== key));
  };

  //valiates the coupon code and apply coupon discount
  // const couponValidator = () => {
  //   if (coupon.length === 0) {
  //     alert("No avilable coupons. Create one on Ghoshak Business app.");
  //     return;
  //   }
  //   const [couponObj] = coupon.filter((data) => data.couponCode === couponCode);
  //   if (couponObj === undefined) {
  //     alert("Invalid coupon code. Please enter a valid one.");
  //     return;
  //   }
  //   setItemBillInput({ ...itemBillInput, billCoupon: couponObj.amount });
  //   setDiscountType({
  //     ...discountType,
  //     couponDiscountType: couponObj.unit,
  //   });
  // };
  //handles extra charges field added by the merchant

  const chargesAddButtonHandler = () => {
    setBillLineSettings({
      ...billLineSettings,
      otherChargesField: [
        ...billLineSettings.otherChargesField,
        {
          id: uuidv4(),
          name: chargesName,
          price: "",
        },
      ],
    });
    setChargesName("");
  };
  //delete the added custom charges
  const deleteChargeHandler = (id) => {
    var deleteCharge = billLineSettings.otherChargesField.filter(
      (data) => data.id !== id
    );
    setBillLineSettings({
      ...billLineSettings,
      otherChargesField: [...deleteCharge],
    });
  };

  ////////////////////////////////////////////////////////////////////////////
  /////////////////////////billing calculation////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////

  //calculate sub total

  useEffect(() => {
    if (addedProducts.length > 0) {
      var billSubTotal = 0;
      addedProducts.forEach((data) => {
        billSubTotal += parseFloat(data.itemTotal);
      });
      setSubTotal(billSubTotal);
    } else {
      setBillLineSettings((prev) => ({
        ...prev,
        otherChargesField: [
          ...billLineSettings.otherChargesField.map((arrData) => {
            return {
              ...arrData,
              price: "",
            };
          }),
        ],
      }));

      setItemBillInput({
        ...itemBillInput,
        billDiscount: 0,
      });
      setAppliedCoupon({});
      setSubTotal(0);
      setItemBillResult({
        ...itemBillResult,
        billTotalAfterCharges: 0.0,
      });
      setItemBillResult({
        ...itemBillResult,
        billTotalAfterCoupon: 0.0,
      });

      setSummedOtherCharges("0.00");
    }
  }, [addedProducts]);

  //bill discount useEffect////

  ///bill tax useEffect////
  useEffect(() => {
    var billTotalAfterTax = parseFloat(itemBillResult.billTotalBeforeTax);
    console.log("billTotalAfterTax", billTotalAfterTax);
    if (billLineSettings.tax) {
      let tax = itemBillInput.billTax;
      if (tax === "") tax = 0;
      billTotalAfterTax =
        billTotalAfterTax + (billTotalAfterTax * parseFloat(tax)) / 100;
    }
    setItemBillResult({
      ...itemBillResult,
      billTotalAfterTax: billTotalAfterTax.toFixed(2),
    });
  }, [
    billLineSettings.tax,
    itemBillInput.billTax,
    itemBillResult.billTotalBeforeTax,
  ]);

  ///custom charge useEffect////
  useEffect(() => {
    var billTotalAfterCharges = parseFloat(itemBillResult.billTotalAfterTax);
    // if (invoiceSettings.othercharges && billTotalAfterCharges !== 0) {
    console.log("summedOtherChargesINsideff", summedOtherCharges);
    if (invoiceSettings.othercharges) {
      let charge = 0;
      if (parseFloat(summedOtherCharges)) {
        console.log("caminsideuse");
        charge = summedOtherCharges;
      }
      billTotalAfterCharges += parseFloat(charge);
      console.log("camoutsideuse", billTotalAfterCharges);
    }
    setItemBillResult({
      ...itemBillResult,
      billTotalAfterCharges: billTotalAfterCharges.toFixed(2),
    });
  }, [
    summedOtherCharges,
    invoiceSettings.othercharges,
    itemBillResult.billTotalAfterTax,
  ]);

  useEffect(() => {
    var billTotalAfterLoyalty = parseFloat(
      itemBillResult.billTotalAfterCharges
    );
    if (billLineSettings.reedemPoints) {
      let loyalty = itemBillInput.billLoyaltyDiscount;
      if (loyalty === "") loyalty = 0;
      if (discountType.loyaltyDiscountType === "flat") {
        billTotalAfterLoyalty = billTotalAfterLoyalty - parseFloat(loyalty);
      }
      if (discountType.loyaltyDiscountType === "percentage") {
        billTotalAfterLoyalty =
          billTotalAfterLoyalty -
          (billTotalAfterLoyalty * parseFloat(loyalty)) / 100;
      }
    }
    setItemBillResult({
      ...itemBillResult,
      billTotalAfterLoyalty: billTotalAfterLoyalty.toFixed(2),
    });
    if (
      Object.keys(appliedCoupon).length > 0 &&
      billTotalAfterLoyalty < appliedCoupon.condition.minPrice
    )
      setAppliedCoupon({});
  }, [
    billLineSettings.reedemPoints,
    discountType.loyaltyDiscountType,
    itemBillInput.billLoyaltyDiscount,
    itemBillResult.billTotalAfterCharges,
  ]);

  useEffect(() => {
    var billTotalBeforeTax = parseFloat(subTotal);
    if (invoiceSettings.adddiscount) {
      let discount = itemBillInput.billDiscount;
      if (discount === "") discount = 0;
      if (discountType.billDiscountType === "flat") {
        billTotalBeforeTax = billTotalBeforeTax - parseFloat(discount);
      }
      if (discountType.billDiscountType === "percentage") {
        billTotalBeforeTax =
          billTotalBeforeTax -
          (billTotalBeforeTax * parseFloat(discount)) / 100;
      }
    }
    console.log("billTotalBeforeTax", billTotalBeforeTax);
    setItemBillResult((prev) => ({
      ...prev,
      billTotalBeforeTax: billTotalBeforeTax.toFixed(2),
    }));
  }, [
    discountType.billDiscountType,
    invoiceSettings.adddiscount,
    itemBillInput.billDiscount,
    subTotal,
  ]);

  ////loyalty useEffect/////

  ////coupon useEffect////

  useEffect(() => {
    var billTotalAfterCoupon = parseFloat(itemBillResult.billTotalAfterLoyalty);
    var couponAmount = 0;
    if (Object.keys(appliedCoupon).length > 0) {
      let coupon = appliedCoupon.discountAmount;
      if (coupon === "") coupon = 0;
      if (appliedCoupon.discountType === "flat") {
        billTotalAfterCoupon = billTotalAfterCoupon - parseFloat(coupon);
        couponAmount = parseFloat(coupon);
      }
      if (appliedCoupon.discountType === "percentage") {
        couponAmount = (billTotalAfterCoupon * parseFloat(coupon)) / 100;
        billTotalAfterCoupon =
          billTotalAfterCoupon -
          (billTotalAfterCoupon * parseFloat(coupon)) / 100;
      }
    }
    setItemBillResult((prev) => ({
      ...prev,
      billTotalAfterCoupon: billTotalAfterCoupon.toFixed(2),
      couponDiscountAmount: couponAmount,
    }));
  }, [
    // billLineSettings.coupon,
    itemBillResult.billTotalAfterLoyalty,
    appliedCoupon,
    itemBillResult.billTotalBeforeTax,
  ]);

  const couponValidator = (coupon) => {
    if (parseFloat(subTotal) >= parseFloat(coupon.condition.minPrice)) {
      setAppliedCoupon(coupon);
      setOffersModal(false);
      setPromoCode("");
      return;
    }
    alert(
      `Cannot Apply coupon. The bill value should be more than ${country.CurrencySymbol}.${coupon.condition.minPrice} to avail this coupon.`
    );
  };

  ////prePaid useEffect////
  useEffect(() => {
    var billFinalTotal = parseFloat(itemBillResult.billTotalAfterCoupon);
    if (billLineSettings.prepaidAmount) {
      let prePaid = itemBillInput.billPrepaid;
      if (prePaid === "") prePaid = 0;
      billFinalTotal = billFinalTotal - parseFloat(prePaid);
    }
    setItemBillResult((prev) => ({
      ...prev,
      ...(invoiceSettings.roundOff && {
        roundOffAmount: Math.round(billFinalTotal) - parseFloat(billFinalTotal),
      }),
      billFinalTotal: invoiceSettings.roundOff
        ? Math.round(billFinalTotal.toFixed(2))
        : billFinalTotal.toFixed(2),
    }));
  }, [
    billLineSettings.prepaidAmount,
    itemBillResult.billTotalAfterCoupon,
    itemBillInput.billPrepaid,
    invoiceSettings.roundOff,
  ]);

  ////paid amount useEffect////
  // useEffect(() => {
  //   let paidAmount = itemBillInput.billPaidAmount;
  //   if (paidAmount === "") paidAmount = 0;
  //   if (paymentMethod === "cash") {
  //     let billAmountDue = parseFloat(itemBillResult.billFinalTotal);
  //     billAmountDue = billAmountDue - parseFloat(paidAmount);
  //     setItemBillResult({
  //       ...itemBillResult,
  //       billAmountDue: billAmountDue.toFixed(2),
  //       billPaidAmount: paidAmount,
  //     });
  //   } else if (paymentMethod === "card") {
  //     setItemBillResult({
  //       ...itemBillResult,
  //       billAmountDue: 0,
  //       billPaidAmount: parseFloat(itemBillResult.billFinalTotal).toFixed(2),
  //     });
  //   } else if (paymentMethod === "upi") {
  //     setItemBillResult({
  //       ...itemBillResult,
  //       billAmountDue: 0,
  //       billPaidAmount: parseFloat(itemBillResult.billFinalTotal).toFixed(2),
  //     });
  //   } else if (paymentMethod === "credit") {
  //     setItemBillResult({
  //       ...itemBillResult,
  //       billAmountDue: parseFloat(itemBillResult.billFinalTotal).toFixed(2),
  //       billPaidAmount: 0,
  //     });
  //   }
  // }, [
  //   billLineSettings.paidAmount,
  //   itemBillResult.billFinalTotal,
  //   itemBillInput.billPaidAmount,
  //   paymentMethod,
  // ]);

  /////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////calculation ending/////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////

  var timer;
  // useEffect(() => {
  //   timer = setTimeout(() => {
  //     var filteredProd = addedProducts.filter((data) => {
  //       if (!data.productEANCode) return false;
  //       else if (data.productEANCode === productCode) return true;
  //       else return false;
  //     });
  //     if (filteredProd.length > 0) {
  //       updateExsistingProduct(filteredProd[0].productId);
  //       setProductCode("");
  //       return;
  //     }
  //     getRelatedProducts(productCode, "fromScan");
  //   }, 500);
  // }, [productCode]);

  // const searchProductFromDb = async (from, searchKey) => {
  //   try {
  //     var res = await fetch(`${config.ApiGateway1}/v1/search/products`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         shopId,
  //         from: from,
  //         searchKey: searchKey,
  //       }),
  //     });
  //     res = await res.json();
  //     if (res.code === "ERROR") {
  //       return [];
  //     }
  //     return res.data;
  //   } catch (err) {
  //     console.error("Err", err);
  //     return [];
  //   }
  // };

  // const getRelatedProducts = (searchKey, from) => {
  //   if (searchKey === "") {
  //     setProductArray([]);
  //     return;
  //   }
  //   const searchDebounce = debounce(async () => {
  //     let data = await searchProducts(searchKey, from);
  //     if (data.hits.hits === undefined) return;
  //     let arr = data.hits.hits.map((data) => data._source);
  //     if (from === "fromScan") {
  //       if (data.hits.hits.length >= 1) {
  //         addItemHandler(
  //           {
  //             ...arr[0],
  //             count: 1,
  //             isExist: true,
  //           },
  //           from
  //         );
  //         return;
  //       }
  //       if (data.hits.hits.length === 0) {
  //         let dbRes = await searchProductFromDb("fromScan", searchKey);
  //         if (dbRes.length > 0) {
  //           addItemHandler(
  //             {
  //               ...dbRes[0],
  //               count: 1,
  //               isExist: true,
  //             },
  //             from
  //           );
  //           return;
  //         }
  //         setItemBillInput({
  //           ...itemBillInput,
  //           itemEANCode: searchKey,
  //         });
  //         setItemNotFound(true);
  //         return;
  //       }
  //     }
  //     if (data.hits.hits.length === 0) {
  //       let dbRes = await searchProductFromDb("fromDes", searchKey);
  //       if (dbRes.length > 0) {
  //         setProductArray(dbRes);
  //         return;
  //       }
  //       setProductArray([]);
  //       return;
  //     }
  //     setProductArray(arr);
  //   }, 300);
  //   searchDebounce();

  //   const searchProducts = async (val, from) => {
  //     var encodedString = window.btoa(
  //       `${config.openSearchUserName}:${config.openSearchPassword}`
  //     );
  //     var query;

  //     if (from === "fromDes") {
  //       query = {
  //         query: {
  //           bool: {
  //             must: [
  //               {
  //                 match: {
  //                   shopId: shopId,
  //                 },
  //               },
  //               {
  //                 bool: {
  //                   should: [
  //                     {
  //                       match_phrase_prefix: {
  //                         productName: {
  //                           query: val,
  //                         },
  //                       },
  //                     },
  //                     {
  //                       match_phrase_prefix: {
  //                         productEANCode: {
  //                           query: val,
  //                         },
  //                       },
  //                     },
  //                     {
  //                       match_phrase_prefix: {
  //                         productCode: {
  //                           query: val,
  //                         },
  //                       },
  //                     },
  //                   ],
  //                 },
  //               },
  //               {
  //                 match: {
  //                   latest: "true",
  //                 },
  //               },
  //             ],
  //             must_not: [
  //               {
  //                 match: {
  //                   productPrice: "TBD",
  //                 },
  //               },
  //             ],
  //             should: [
  //               {
  //                 match: {
  //                   status: "live",
  //                 },
  //               },
  //               {
  //                 match: {
  //                   status: "ported",
  //                 },
  //               },
  //             ],
  //           },
  //         },
  //       };
  //     } else {
  //       query = {
  //         query: {
  //           bool: {
  //             must: [
  //               {
  //                 match: {
  //                   shopId: shopId,
  //                 },
  //               },
  //               {
  //                 match_phrase_prefix: {
  //                   productEANCode: {
  //                     query: val,
  //                   },
  //                 },
  //               },
  //               {
  //                 match: {
  //                   latest: "true",
  //                 },
  //               },
  //             ],
  //             must_not: [
  //               {
  //                 match: {
  //                   productPrice: "TBD",
  //                 },
  //               },
  //             ],
  //             should: [
  //               {
  //                 match: {
  //                   status: "live",
  //                 },
  //               },
  //               {
  //                 match: {
  //                   status: "ported",
  //                 },
  //               },
  //             ],
  //           },
  //         },
  //       };
  //     }
  //     return await Promise.all([
  //       fetch(`${config.OpenSearch}/products/_search?size=10`, {
  //         method: "POST",
  //         body: JSON.stringify(query),
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: "Basic " + encodedString,
  //         },
  //       }),
  //     ])
  //       .then(([response]) => Promise.all([response.json()]))
  //       .then(async ([data]) => {
  //         return data;
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //       });
  //   };
  // };

  /* Get customer details */
  // const getCustomerDetails = async (customerPhoneNumber, blockNumber) => {
  //   // const regExp = /^[0]?[56789]\d{9}$/;
  //   // if (regExp.test(customerPhoneNumber) === false) {
  //   //   setTimeout(() => {
  //   //     alert("Enter valid phone number");
  //   //   }, 100);
  //   //   return;
  //   // }
  //   await Promise.all([
  //     fetch(`${config.ApiGateway1}/getCustomerDetails`, {
  //       method: "POST",
  //       body: JSON.stringify({
  //         phoneNumber: `${shopDetails.country.dialCode}${customerPhoneNumber}`,
  //         shopId: shopDetails.shopId,
  //       }),
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     }),
  //   ])
  //     .then(([res]) => Promise.all([res.json()]))
  //     .then(async ([data]) => {
  //       if (data.customerName !== null) setCustomerName(data.customerName);
  //       setLoyaltyPoints(data.loyaltyPoints);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // };

  const handleUniqueIdentityChange = (e) => {
    if (CustomerFoundFrom === "alias") {
      setCustomerPhoneNumber("");
      setCustomerName("");
    }
    const _uniqueId = e.target.value;
    setUniqueId(_uniqueId);
    getCustomerDetail(undefined, _uniqueId);
    setCustomerFoundFrom();
    setLoyaltyPoints(0);
    setOutStanding(0);
    // setCustomerName("");
    // setCustomerPhoneNumber("");
  };

  const handleCustomerNumberChange = (e) => {
    console.log("value,value", e);
    const value = e.target.value;
    setCustomerPhoneNumber(value);
    setOutStanding(0);
    if (CustomerFoundFrom === "phoneNumber") {
      setUniqueId("");
    }
    if (value === "" || value.length !== mobileNumberLimit) {
      setLoyaltyPoints(0);
      setOutStanding(0);
      setCustomerName("");
      setAppliedLoyalty({});
      setCustomerFoundFrom();
      return;
    }
    // setCustomerPhoneNumber(value);
    // if (value.length !== mobileNumberLimit) {
    //   return;
    // }
    const regExp = /^[0]?[56789]\d{9}$/;
    if (regExp.test(value) === false) {
      setTimeout(() => {
        alert("Enter valid phone number");
      }, 100);
      return;
    }
    setCustomerDetailsLoading(true);
    getCustomerDetail(value);
  };
  // useEffect(() => {
  //   if (customerPhoneNumber.length > 0 && !CustomerFoundFrom) {
  //     handleCustomerNumberChange(customerPhoneNumber);
  //   }
  // }, [customerPhoneNumber, CustomerFoundFrom]);

  const getCustomerDetail = async (customerPhoneNo, uniqueId) => {
    await Promise.all([
      fetch(`${config.newApiGateway}/customer/getCustomerDetailswithLoyalty`, {
        method: "POST",
        body: JSON.stringify({
          shopId: shopDetails.shopId,
          ...(identifier && uniqueId
            ? { uniqueIdentity: uniqueId }
            : {
                phoneNumber: customerPhoneNo
                  ? `${shopDetails.country.dialCode}${customerPhoneNo}`
                  : undefined,
              }),
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        if (data.code === "ERROR") {
          setCustomerName("");
          setLoyaltyPoints(0);
          setOutStanding(0);
        }
        console.log("getCustomerDetails", data);
        if (data.customerName) {
          setCustomerName(data.customerName);
        }
        if (data.customerPhoneNumber) {
          setCustomerPhoneNumber(
            data.customerPhoneNumber.replace(shopDetails.country.dialCode, "")
          );
        }
        if (
          identifier &&
          uniqueId &&
          data.customerPhoneNumber &&
          data.customerName
        ) {
          setCustomerFoundFrom("alias");
        } else if (
          data.customerPhoneNumber &&
          data.customerName &&
          data.uniqueIdentity
        ) {
          setCustomerFoundFrom("phoneNumber");
        }
        if (data.uniqueIdentity) {
          setUniqueId(data.uniqueIdentity);
        }
        setLoyaltyPoints(data.loyaltyPoints);
        setOutStanding(data.outStanding);
      })
      .catch((err) => {
        setCustomerName("");
        setCustomerPhoneNumber("");
        setCustomerFoundFrom();
        setLoyaltyPoints(0);
        setOutStanding(0);
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
        setCustomerDetailsLoading(false);
      });
  };

  const updateSettings = async () => {
    //newlyadded
    let tempSet = { ...billLineSettings };
    tempSet.otherChargesField = [
      ...billLineSettings.otherChargesField.map((arrData) => {
        return {
          ...arrData,
          price: "",
        };
      }),
    ];
    //newlyadded
    return await Promise.all([
      fetch(`${config.newApiGateway}/tools/shopDetailsUpdate`, {
        method: "POST",
        body: JSON.stringify({
          userId: shopId,
          settings: tempSet,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        return data;
      })
      .catch((err) => {
        console.error("update settings", err);
      });
  };

  const processInvoiceHelperFunction = (num) => {
    let tempInvoiceNum = parseInt(num);
    tempInvoiceNum = tempInvoiceNum + 1;
    if (tempInvoiceNum.toString().length - num.length < 0) {
      let tempLength = tempInvoiceNum.toString().length;
      for (var i = 0; i < num.length - tempLength; i++) {
        tempInvoiceNum = "0" + tempInvoiceNum;
      }
    }
    // setInvoiceNumber(tempInvoiceNum.toString());
    return tempInvoiceNum.toString();
  };

  const processInvoiceNumber = (num, save) => {
    if (num === undefined) return "";
    if (save) {
      updateSettings();
      dispatch({
        type: "SET_SETTINGS",
        payload: billLineSettings,
      });
      return processInvoiceHelperFunction(num);
    }
    return processInvoiceHelperFunction(num);
  };

  useEffect(() => {
    setBillDraft(draftedBills);
  }, [draftedBills]);

  // useEffect(() => {
  //   if (
  //     employeeObj === undefined ||
  //     employeeObj === null ||
  //     Object.keys(employeeObj).length === 0
  //   )
  //     return;
  //   var arr = Object.entries(employeeObj).map((data) => ({
  //     [data[0]]: data[1],
  //   }));
  //   setEmployeeArr(arr);
  // }, [employeeObj]);

  const handleHoldBill = () => {
    if (addedProducts.length === 0)
      return alert("Nothing added in the bill to hold.");
    var dateTime = new Date().toLocaleTimeString();
    var date = new Date().toISOString().substring(0, 10);
    var dBill = {
      billId: uuidv4(),
      products: addedProducts,
      customerName: customerName,
      customerPhoneNumber: customerPhoneNumber,
      billDate: date + " " + dateTime,
      billTotal: itemBillResult.billFinalTotal,
      numberOfItems: addedProducts.length,
      discountType: discountType.billDiscountType,
      discountAmount: itemBillInput.billDiscount,
      billingAddress: billShipAddress.billingAddress
        ? billShipAddress.billingAddress
        : "",
      ...(notes && {
        notes: notes,
      }),
      loyaltyPoints: loyaltyPoints,
      outStanding: outStanding,
      shippingAddress: billShipAddress.shippingAddress
        ? billShipAddress.shippingAddress
        : "",
      ...(CustomerFoundFrom && { CustomerFoundFrom: CustomerFoundFrom }),
      ...(uniqueId && { uniqueId: uniqueId }),
      // setBillShipAddress({
      //   ...billShipAddress,
      //   billingAddress: e.target.value,
      //   shippingAddress: e.target.value,
      // });
      // discountAmount:itemBillInput
      // discountAmount: discountAmount,
    };
    dispatch({
      type: "SET_BILL_DRAFT",
      payload: [...billDraft, dBill],
    });
    setNotes("");
    setUniqueId("");
    setCustomerFoundFrom();
    setAddedProducts([]);
    setCustomerPhoneNumber("");
    setCustomerName("");
    setPaymentMethod([]);
    setToInitialState("hold");
    setSummedOtherCharges("0.00");
    setOutStanding(0);
    setAppliedLoyalty({});
    setBillShipAddress({
      billingAddress: "",
      shippingAddress: "",
    });
    storeDraftToLocalStorage([...billDraft, dBill]);
    alert("Bill Hold success");
    console.log("paymentMethodafterhold", paymentMethod);
  };

  // shortcut keys

  const handleDeleteDraftBill = (billId) => {
    var filteredArr = billDraft.filter((data) => data.billId !== billId);
    setBillDraft([...filteredArr]);
    dispatch({
      type: "SET_BILL_DRAFT",
      payload: filteredArr,
    });
    storeDraftToLocalStorage(filteredArr);
  };

  const handleDraftRemoveAll = () => {
    setBillDraft([]);
    dispatch({
      type: "SET_BILL_DRAFT",
      payload: [],
    });
    storeDraftToLocalStorage([]);
  };

  const moveDraftToCurrent = (data) => {
    const updatedBillItem = data.products.map((i) => {
      if (i.isExist === false) {
        return i;
      }
      const getObj = products.find((j) => j.productId === i.productId);

      if (getObj) {
        const getUpdatedPrice = itemDiscountCalc(
          getObj.productPrice,
          getObj.discountPrice,
          getObj.discountType
        );
        const updatedPorduct = getTaxableValueAndTaxs(
          getObj,
          getObj.productPrice,
          getUpdatedPrice,
          i.count
        );
        return {
          ...i,
          ...updatedPorduct,
          productPrice: getObj.productPrice,
          count: i.count,
        };
      } else if (i.isExist === false) {
        return i;
      }
    });
    let temp = updatedBillItem.filter((Data) => {
      if (Data) {
        return Data;
      }
    });
    setAddedProducts(temp);
    setCustomerName(data.customerName);
    setCustomerPhoneNumber(data.customerPhoneNumber);
    if (data.notes) {
      setNotes(data.notes);
    }
    setDiscountType((prev) => ({
      ...prev,
      billDiscountType: data.discountType,
    }));
    setItemBillInput((prev) => ({
      ...prev,
      billDiscount: data.discountAmount,
    }));
    setBillShipAddress({
      ...billShipAddress,
      billingAddress: data.billingAddress,
      shippingAddress: data.shippingAddress,
    });
    setCurrentDraft(!currentDraft);
    var filteredArr = billDraft.filter((prod) => prod.billId !== data.billId);
    setBillDraft([...filteredArr]);
    if (data.uniqueId) {
      setUniqueId(data.uniqueId);
    }
    if (data.CustomerFoundFrom) {
      setCustomerFoundFrom(data.CustomerFoundFrom);
    }
    if (data.loyaltyPoints) {
      setLoyaltyPoints(data.loyaltyPoints);
    }
    setCustomerDetailsLoading(true);
    getCustomerDetail(data.customerPhoneNumber);
    if (data.outStanding) {
      setOutStanding(data.outStanding);
    }
    dispatch({
      type: "SET_BILL_DRAFT",
      payload: filteredArr,
    });
    storeDraftToLocalStorage(filteredArr);
    setPaymentMethod([]);

    // setItemBillResult({
    //   ...itemBillResult,
    //   billFinalTotal: data.billTotal,
    // })
  };
  useEffect(() => {
    if (creditSale) {
      setAmountPaidUsingUpi("");
      setAmountPaidUsingCard("");
      setAmountPaidUsingCash("");
      setCardNumber("");
      setPaymentMethodForThermal(["credit"]);
    } else {
      setPaymentMethodForThermal([]);
    }
  }, [creditSale]);
  var storeDraftToLocalStorage = (bill) => {
    var res = window.localStorage.getItem("draftBill");
    if (res !== null) {
      window.localStorage.removeItem("draftBill");
      window.localStorage.setItem("draftBill", JSON.stringify(bill));
    } else {
      window.localStorage.setItem("draftBill", JSON.stringify(bill));
    }
  };

  useEffect(() => {
    var res = window.localStorage.getItem("draftBill");
    if (res !== null) {
      dispatch({
        type: "SET_BILL_DRAFT",
        payload: JSON.parse(res),
      });
    }
    var res = window.localStorage.getItem("checkBill");
    if (res !== null) {
      dispatch({
        type: "CHECK_BILL",
        payload: JSON.parse(res),
      });
    }
  }, []);

  var interval;

  // It is not in use
  // const checkBillFunction = async () => {
  //   var bills = checkBill;
  //   await fetch(`${config.ApiGateway1}/checkBill`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(bills),
  //   });
  //   removeCheckBillFromLocalStorage(bills);
  // };

  // useEffect(() => {
  //   interval = setInterval(async () => {
  //     await checkBillFunction();
  //   }, 60000 * 30);
  //   return () => clearInterval(interval);
  // }, []);

  var removeCheckBillFromLocalStorage = (bill) => {
    var idArr = bill.map((data) => data.billId);
    var filteredArr = checkBill.filter((data) => idArr.includes(data.billId));
    dispatch({
      type: "CHECK_BILL",
      payload: [...filteredArr],
    });
    var res = window.localStorage.getItem("checkBill");
    if (res !== null) {
      window.localStorage.removeItem("checkBill");
      window.localStorage.setItem("checkBill", JSON.stringify(filteredArr));
    } else {
      window.localStorage.setItem("checkBill", JSON.stringify(filteredArr));
    }
  };

  var storeCheckBillToLocalStorage = (bill) => {
    var res = window.localStorage.getItem("checkBill");
    if (res !== null) {
      window.localStorage.removeItem("checkBill");
      window.localStorage.setItem("checkBill", JSON.stringify(bill));
    } else {
      window.localStorage.setItem("checkBill", JSON.stringify(bill));
    }
  };

  const newValidator = async (isSms = false) => {
    if (customerPhoneNumber === "" && itemBillResult.billAmountDue > 0) {
      return alert("Please enter customer details for credit sales.");
    }
    let tempArray = [];

    if (!creditSale) {
      if (!amountPaidUsingCard && !amountPaidUsingCash && !amountPaidUsingUpi) {
        setPaymentMethod([]);
        return alert("Please Enter The Received Amount");
      }
      if (amountPaidUsingCash) {
        var cashObj = {
          method: "cash",
          paidAmount: amountPaidUsingCash,
        };
        tempArray.push(cashObj);
      }
      if (amountPaidUsingUpi) {
        var upiObj = {
          method: "upi",
          paidAmount: amountPaidUsingUpi,
        };
        tempArray.push(upiObj);
      }
      if (amountPaidUsingCard) {
        var cardObj = {
          method: "card",
          cardType: cardType,
          cardNumber: cardNumber,
          paidAmount: amountPaidUsingCard,
        };
        tempArray.push(cardObj);
      }
    } else {
      var creditObj = {
        method: "credit",
      };
      tempArray.push(creditObj);

      setItemBillResult({
        ...itemBillResult,
        billAmountDue: itemBillResult.billFinalTotal,
        billPaidAmount: 0,
      });
      setAmountPaidUsingCard("");
      setAmountPaidUsingCash("");
      setAmountPaidUsingUpi("");
    }
    let tempObject = {};
    if (tempArray.length > 1) {
      tempArray.forEach((data) => {
        tempObject[data.method] = data;
      });
      tempArray = Object.values(tempObject);
    }
    setPaymentMethod(tempArray);
    tempArray = [];
    handleBeforePrint();
  };

  const handleBeforePrint = async () => {
    if (invoiceSettings.adddiscount) {
      if (
        (itemBillInput.billDiscount !== "" ||
          parseInt(itemBillInput.billDiscount) !== 0) &&
        discountType.billDiscountType === ""
      )
        return alert("Please select discount type.");
    }
    setBillLoading(true);
    setBillPrint(true);
  };
  useEffect(() => {
    console.log("customerName", customerName);
  }, [customerName]);

  const generateBill = async (pdf) => {
    if (itemBillInput.billPaidAmount === "" && paymentMethod === "cash") {
      return alert("Please enter the Received amount");
    }
    if (billLineSettings.modeOfPayment && paymentMethod === "")
      return alert("Please select payment method");
    if (invoiceSettings.adddiscount) {
      if (
        (itemBillInput.billDiscount !== "" ||
          parseInt(itemBillInput.billDiscount) !== 0) &&
        discountType.billDiscountType === ""
      )
        return alert("Please select discount type.");
    }

    setBillLoading(true);

    // const billingItems = addedProducts.map((item) => {
    //   let sgst = 0,
    //     cgst = 0;
    //   if (item.gst) {
    //     sgst = parseFloat(item.gst / 2);
    //     cgst = parseFloat(item.gst / 2);
    //   }
    //   return {
    //     ...item,
    //     sgst,
    //     cgst,
    //   };
    // });

    setBillPrint(true);
  };

  const billGenerate = async () => {
    const currentDate = moment().format("YYYY-MM-DD");
    var billBody = {
      shopId: shopId,
      isSms: isSms,
      billId: uuidv4(),
      customerName: customerName === "" ? "NA" : customerName,
      customerPhoneNumber:
        customerPhoneNumber === ""
          ? "NA"
          : `${shopDetails.country.dialCode}${customerPhoneNumber}`,
      customerDetailsEnabled: true,
      ...(invoiceSettings.roundOff && {
        roundOff: itemBillResult.roundOffAmount,
      }),
      billingDate: currentDate,
      items: addedProducts,
      billVersion: 1,
      paymentMethod: paymentMethod,
      shippingAddress: billShipAddress.shippingAddress,
      billingAddress: billShipAddress.billingAddress,
      dueDate: dueDate,
      employeeName: employee,
      discount: invoiceSettings.adddiscount
        ? itemBillInput.billDiscount
          ? itemBillInput.billDiscount
          : 0
        : 0,
      discountType: invoiceSettings.adddiscount
        ? discountType.billDiscountType
        : "NA",
      invoiceNumber: invoiceSettings.currentInvoiceNumber,
      productTotal: itemBillResult.billFinalTotal,
      balanceAmount: itemBillResult.billAmountDue,
      walletAmount: itemBillResult.walletAmount,
      subTotal: subTotal,
      loyalty: billLineSettings.reedemPoints
        ? itemBillInput.billLoyaltyDiscount
        : 0,
      loyaltyDiscountType: billLineSettings.reedemPoints
        ? discountType.loyaltyDiscountType
        : "NA",
      taxAmount: itemBillInput.billTax,
      coupon: billLineSettings.coupon ? itemBillInput.billCoupon : 0,
      couponDiscountType: billLineSettings.coupon
        ? discountType.couponDiscountType
        : "NA",
      otherCharges: billLineSettings.otherChargesField,
      cameFrom: "NA",
      notes: notes,
      extraFields: {
        wastage: false,
        labour: false,
        tax: invoiceSettings.itemleveltax,
        discount: invoiceSettings.itemdiscount,
        hsnCode: invoiceSettings.hsncode,
        mrp: invoiceSettings.itemmrp,
        otherCharges: invoiceSettings.othercharges,
      },
      remainder: "",
      tAndC: invoiceSettings.termscondition ? invoiceSettings.tAndCField : "",
      paymentTerms: invoiceSettings.paymenyterms
        ? invoiceSettings.paymentTermsField
        : "",
      invoicePrefix: invoiceSettings.invoiceprefix
        ? invoiceSettings.invoicePrefixtext
        : "",
      invoiceTemplate: billLineSettings.invoiceTemplate,
      coupon: appliedCoupon,
      loyalty: appliedLoyalty,
      couponDiscountAmount: itemBillResult.couponDiscountAmount,
      loyaltyPoints: loyaltyPoints,
      printerType: invoiceSettings.printerType,
      cardType: cardType,
      cardNumber: cardNumber,
      taxList: taxList,
      employeeId: shopDetails.empId ? shopDetails.empId : "",
      counterId: counterId,
      ...(Boolean(identifier && uniqueId) && {
        uniqueIdentity: uniqueId,
      }),
      ...(["Employee", "Outlet"].includes(shopDetails.userType) && {
        parentShopId: shopDetails.ownerShopId,
      }),
    };
    console.log("billBody", billBody);
    if (
      invoiceSettings.printerType !== " " &&
      Object.keys(shopDetails).length > 0
    ) {
      try {
        var res = await fetch(`${config.newApiGateway}/bill/generateBill`, {
          method: "POST",
          body: JSON.stringify(billBody),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        });
        res = await res.json();
        console.log("res", res);
        if (res.code === "SUCCESS") {
          confirmRef.current.click();
          dispatch({
            type: "CHECK_BILL",
            payload: [billBody, ...checkBill],
          });
          const UpdatedProductList = products.map((i) => {
            const getObj = addedProducts.find(
              (j) => i.productId === j.productId
            );
            if (getObj) {
              return {
                ...i,
                inventoryQty:
                  parseFloat(i.inventoryQty) - parseFloat(getObj.count),
              };
            }
            return i;
          });
          dispatch({
            type: "SET_PRODUCT_LIST",
            payload: UpdatedProductList,
          });
          setInitialStateSuccess(res.nextInvoiceNumber);
          storeCheckBillToLocalStorage([...checkBill, billBody]);

          // a4BillTemplate(shopDetails, billBody, billLineSettings, "generate");

          setBillPrint(false);
          setAmountPaidUsingCard("");
          setAmountPaidUsingCash("");
          setAmountPaidUsingUpi("");
          setPaymentMethod([]);
          setSummedOtherCharges("0.00");
          setPaymentMethodForThermal([]);
          setBillLineSettings((prev) => ({
            ...prev,
            otherChargesField: [
              ...billLineSettings.otherChargesField.map((arrData) => {
                return {
                  ...arrData,
                  price: "",
                };
              }),
            ],
          }));
          setCreditSale(false);
        }
        setAmountPaidUsingCard("");
        setAmountPaidUsingCash("");
        setAmountPaidUsingUpi("");
        setPaymentMethod([]);
        setSummedOtherCharges("0.00");
        setOutStanding(0);
        setAppliedLoyalty({});
        setBillLineSettings((prev) => ({
          ...prev,
          otherChargesField: [
            ...billLineSettings.otherChargesField.map((arrData) => {
              return {
                ...arrData,
                price: "",
              };
            }),
          ],
        }));
        setItemBillInput({
          ...itemBillInput,
          taxId: "",
          taxIncExc: "",
          itemName: "",
          itemRate: "",
          itemQuantity: "",
          itemMRP: "",
          itemDiscount: "",
          itemWastage: "",
          itemEANCode: "",
          itemPurchasePrice: "",
          itemLabour: "",
          itemHsnCode: "",
          itemLevelTax: "",
          itemTaxType: "",
          imei1: "",
          imei2: "",
          unitOfMeasurment: "",
          measurmentValue: "",
          measurmentUnit: "",
          billDiscount: 0,
          billTax: 0,
          billPaidAmount: "",
        });
      } catch (err) {
        alert("Bill generation failed");
        setAmountPaidUsingCard("");
        setAmountPaidUsingCash("");
        setAmountPaidUsingUpi("");
        setPaymentMethod([]);
      } finally {
        setBillLoading(false);
        setBillPrint(false);
        setIsSms(false);
        setToInitialState("generated");
      }
    } else {
      try {
        var data = await fetch(`${config.newApiGateway}/bill/generateBill`, {
          method: "POST",
          body: JSON.stringify(billBody),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        });
        data = await data.json();
        if (data.code === "SUCCESS") {
          a4BillTemplate(
            shopDetails,
            billBody,
            billLineSettings,
            invoiceSettings,
            currencyFormatter
          );
          const UpdatedProductList = products.map((i) => {
            const getObj = addedProducts.find(
              (j) => i.productId === j.productId
            );
            if (getObj) {
              return {
                ...i,
                inventoryQty:
                  parseFloat(i.inventoryQty) - parseFloat(getObj.count),
              };
            }
            return i;
          });
          dispatch({
            type: "SET_PRODUCT_LIST",
            payload: UpdatedProductList,
          });

          setInitialStateSuccess(data.nextInvoiceNumber);
          setAmountPaidUsingCard("");
          setAmountPaidUsingCash("");
          setAmountPaidUsingUpi("");
          setPaymentMethod([]);
          setSummedOtherCharges("0.00");
          setCreditSale(false);
          setPaymentMethodForThermal([]);
          setBillLineSettings((prev) => ({
            ...prev,
            otherChargesField: [
              ...billLineSettings.otherChargesField.map((arrData) => {
                return {
                  ...arrData,
                  price: "",
                };
              }),
            ],
          }));
          setAmountPaidUsingCard("");
          setAmountPaidUsingCash("");
          setAmountPaidUsingUpi("");
          setPaymentMethod([]);
          setSummedOtherCharges("0.00");
          setOutStanding(0);
          setAppliedLoyalty({});
          setBillLineSettings((prev) => ({
            ...prev,
            otherChargesField: [
              ...billLineSettings.otherChargesField.map((arrData) => {
                return {
                  ...arrData,
                  price: "",
                };
              }),
            ],
          }));
          setItemBillInput({
            ...itemBillInput,
            taxId: "",
            taxIncExc: "",
            itemName: "",
            itemRate: "",
            itemQuantity: "",
            itemMRP: "",
            itemDiscount: "",
            itemWastage: "",
            itemEANCode: "",
            itemPurchasePrice: "",
            itemLabour: "",
            itemHsnCode: "",
            itemLevelTax: "",
            itemTaxType: "",
            imei1: "",
            imei2: "",
            unitOfMeasurment: "",
            measurmentValue: "",
            measurmentUnit: "",
            billDiscount: 0,
            billTax: 0,
            billPaidAmount: "",
          });
        }
      } catch (err) {
        alert("Bill generation failed");
        setAmountPaidUsingCard("");
        setAmountPaidUsingCash("");
        setAmountPaidUsingUpi("");
        setPaymentMethod([]);
      } finally {
        setBillLoading(false);
        setBillPrint(false);
        setUniqueId("");
        setCustomerFoundFrom();
        setIsSms(false);
      }
    }
  };

  useEffect(() => {
    if (billPrint) {
      billGenerate();
    }
  }, [billPrint]);

  const setInitialStateSuccess = (invoiceNumber) => {
    setCardNumber("");
    setCardType("");
    // setBillLineSettings((prev) => ({
    //   ...prev,
    //   currentInvoiceNumber: invoiceNumber,
    // }));
    // dispatch({
    //   type: "SET_SETTINGS",
    //   payload: {
    //     ...settings,
    //     currentInvoiceNumber: invoiceNumber,
    //   },
    // });
    dispatch({
      type: "INVOICE-NEWBILLSETTINGS",
      payload: {
        ...invoiceSettings,
        uniqueIdentity: identifier,
        currentInvoiceNumber: invoiceNumber,
      },
    });
    setUniqueId("");
    setCustomerFoundFrom();
    // setBillLineSettings({
    //   ...billLineSettings,
    //   currentInvoiceNumber: itemBillResult.invoiceNumber,
    // });
    setBillConfirm(false);
    setAddedProducts([]);
    setCustomerPhoneNumber("");
    setCustomerName("");
    setBillShipAddress({
      billingAddress: "",
      shippingAddress: "",
    });
    setAddressCheckBox(false);
    //setToInitialState("generated");
    setLoyaltyPoints(0);
    setItemBillResult({
      ...INITIAL_RESULT_STATE,
      invoiceNumber: invoiceSettings.invoiceSuffixField,
    });
  };

  const getCounterOpeningDetails = async () => {
    try {
      var res = await fetch(`${config.newApiGateway}/counter/counter`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          shopId,
          type: "fetch",
          employeeId: shopDetails.empId ? shopDetails?.empId : "",
        }),
      });
      res = await res.json();
      console.log("billingRESS", res);
      if (res.code === "SUCCESS") {
        setLoading(false);
        // console.log("res", res);
        if (!res.counterId) {
          setStarterCounterModal(true);
        } else {
          console.log("counterId", res.counterId);
          setCounterId(res.counterId);
        }
      }
    } catch (err) {
      console.log("Err", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (shopDetails.shopId) {
      if (
        shopDetails.userType !== "Outlet" &&
        shopDetails.empId &&
        !shopDetails.access?.includes("generateReprintBill")
      )
        return props.history.push("/dashboard/overview");
      fetchCoupons();
      fetchLoyaltyCoupon();
      if (settings) {
        setBillLineSettings({ ...settings, taxMaster: [] });
      }

      getCounterOpeningDetails();
    }
  }, [shopDetails, settings]);

  useEffect(() => {
    if (promoCode === "") {
      setCouponArr([...couponArrDefault]);
    }
    var tempArr = couponArrDefault.filter((data) =>
      hasCoupon(promoCode.toUpperCase(), data.promocode) !== -1 ? true : false
    );
    setCouponArr([...tempArr]);
  }, [promoCode]);

  const hasCoupon = (s1, s2) => {
    for (var i = 0; i <= s2.length - s1.length; i++) {
      var j;
      for (j = 0; j < s1.length; j++) if (s2[i + j] != s1[j]) break;
      if (j == s1.length) return i;
    }
    return -1;
  };

  const fetchLoyaltyCoupon = async () => {
    if (shopId === "") return;
    await Promise.all([
      fetch(`${config.newApiGateway}/loyalty/loyalty`, {
        method: "POST",
        body: JSON.stringify({
          shopId: shopDetails.shopId,
          action: "fetchLoyaltyCoupon",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        setLoyaltyArr(data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchCoupons = async () => {
    var res = await fetch(
      `${config.newApiGateway}/coupon/create-Update-delete-get-coupon`,
      {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          shopId: shopDetails.shopId,
          action: "getAllCoupon",
        }),
      }
    );
    res = await res.json();
    if (res.code === "ERROR") {
      setCouponArr([]);
      return;
    }
    if (res.code === "SUCCESS") {
      setCouponArr(res.data);
      setCouponArrDefault(res.data);
    }
  };

  useEffect(() => {
    if (notes.length > 250) {
      var tempNotes = notes;
      setNotes(tempNotes.slice(0, 250));
    }
  }, [notes]);

  // console.log("addedProducts", addedProducts);
  // if (addedProducts.length !== 0) {
  //   // alert("Please add product(s) to generate bill.");
  //   // return;
  //   // { parseFloat(data.itemTotal) === 0 && (deleteItemHandler(data.productId)) }
  // addedProducts.filter(function(value, index, arr){
  //     return value > 5;
  // });
  // }

  // const getInvoiceNumber = async () => {
  //   try {
  //     const response = await fetch(`${config.ApiGateway1}/getInvoiceNumber`, {
  //       method: "POST",
  //       headers: {
  //         "Content-type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         shopId: shopDetails.shopId,
  //       }),
  //     });
  //     const data = await response.json();
  //     return data;
  //   } catch (error) {
  //     console.error("getInvoiceNumber", error);
  //   }
  // };

  const validate = useCallback(() => {
    const reg = new RegExp("^[0-9]*$");

    if (addedProducts.length === 0) {
      alert("Please add product(s) to generate bill.");
      return;
    }
    console.log("addedProducts", addedProducts);
    if (reg.test(customerPhoneNumber) === false) {
      return alert("Please enter valid phone number");
    }
    if (uniqueId && customerPhoneNumber.length === 0) {
      return alert("Please enter customer phone number");
    }
    if (uniqueId && customerPhoneNumber.length < 10) {
      return alert("Please enter valid phone number");
    }
    if (uniqueId && customerPhoneNumber.length === 10 && customerName === "") {
      return alert("Please enter customer name");
    }
    if (customerPhoneNumber.length < 10 && customerPhoneNumber.length >= 1) {
      return alert("Please enter valid phone number");
    }
    if (customerPhoneNumber.length === 10 && customerName === "") {
      return alert("Please enter customer name");
    }
    if (customerName && customerPhoneNumber.length < 10) {
      return alert("Please enter valid phone number");
    }
    if (addedProducts.find((o) => o.itemTotal === 0)) {
      return alert("Delete item with Zero value");
    }
    if (addedProducts.find((o) => o.count === 0 || !o.count)) {
      return alert("please add inventory to item with empty qty");
    }
    if (customerPhoneNumber === "") {
      setCreditSale(false);
    }
    if (invoiceSettings.adddiscount) {
      if (
        parseInt(itemBillInput.billDiscount) !== 0 &&
        discountType.billDiscountType === ""
      )
        return alert("Please select discount type.");
      if (!itemBillInput.billDiscount && discountType.billDiscountType === "")
        return alert("Please select discount type.");
      if (parseFloat(itemBillResult.billFinalTotal) < 0)
        return alert("Total is lesser than Zero.");
    }
    if (!invoiceSettings.adddiscount) {
      setItemBillInput({
        ...itemBillInput,
        billDiscount: 0,
      });
    }
    if (!invoiceSettings.othercharges) {
      setBillLineSettings((prev) => ({
        ...prev,
        otherChargesField: [
          ...billLineSettings.otherChargesField.map((arrData) => {
            return {
              ...arrData,
              price: "",
            };
          }),
        ],
      }));
    }
    setBillConfirm(true);

    // setGeneateBillModal(true);
  }, [
    addedProducts,
    invoiceSettings.adddiscount,
    invoiceSettings.othercharges,
    paymentMethod,
    customerName,
    customerPhoneNumber,
    discountType.billDiscountType,
    itemBillInput.billDiscount,
    subTotal,
    itemBillResult.billFinalTotal,
    uniqueId,
  ]);

  const addItemHandler = (product, from) => {
    delete product.gst;
    delete product.cess;
    delete product.igst;
    delete product.additionalcess;
    delete product.taxType;
    delete product.taxableValue;
    delete product.total;
    delete product.taxType;
    console.log("product122", product);
    if (from !== "fromScan") {
      if (
        invoiceSettings.itemMRP &&
        parseInt(itemBillInput.itemMRP) < parseInt(itemBillInput.itemRate) &&
        itemBillInput.itemMRP !== "" &&
        parseFloat(itemBillInput.itemMRP) !== 0
      ) {
        return message.error("Selling price should not be greater than MRP");
      }
      if (itemBillInput.itemName === "")
        return message.error("Please enter product name in description box");
      if (itemBillInput.itemRate === "")
        return message.error("Please enter selling price");
      // if (itemBillInput.measurmentValue === "")
      //   return message.error("Please enter measurment value");
      if (
        itemBillInput.measurmentUnit === "" &&
        itemBillInput.measurmentValue !== ""
      )
        return message.error("Plese choose measurment unit");
      if (itemBillInput.itemQuantity === "")
        return message.error("Please enter quantity");
      if (
        invoiceSettings.itemdiscount &&
        itemBillInput.itemDiscount !== "" &&
        discountType.itemDiscountType === ""
      )
        return message.error("Please select discount type");
      if (
        invoiceSettings.itemleveltax &&
        itemBillInput.itemLevelTax !== "" &&
        itemBillInput.itemTaxType === ""
      )
        return message.error("Please Choose Tax Type");
    }
    let tempProductId = product.productId;

    setAddedProducts((prev) => {
      // console.log("prev", prev, prev?.length);
      let existingProduct;
      if (prev?.length > 0) {
        existingProduct = prev.find(
          (data) => data?.productId === tempProductId
        );
      }

      if (existingProduct?.productId) {
        const updatedProduct = updateExistingProduct(
          existingProduct.productId,
          existingProduct
        );
        let filteredArr = prev.filter(
          (i) => !i.productId.includes(existingProduct?.productId)
        );
        return [updatedProduct, ...filteredArr];
        // return prev.map((i) => {
        //   if (i.productId === tempProductId) {
        //     return updatedProduct;
        //   }
        //   return i;
        // });
      } else {
        const getUpdatedPrice = itemDiscountCalc(
          product.productPrice,
          product.discountPrice,
          product.discountType
        );
        console.log("getUpdatedPrice", getUpdatedPrice);
        const productObj = getTaxableValueAndTaxs(
          product,
          product.productPrice,
          getUpdatedPrice,
          product.count
        );
        if (product?.isExist) {
          return [
            {
              ...productObj,
              ...(product.taxIncExc
                ? { taxIncExc: product.taxIncExc }
                : product.productTax
                ? { taxIncExc: "inclusive" }
                : ""),
              count: product.count,
              productImageArray: product.productImageArray
                ? product.productImageArray.map((data) => data)
                : [],
            },
            ...prev,
          ];
        } else {
          const result = {
            productName: product.productName,
            addedDate: new Date().toISOString().substring(0, 10),
            productId: product.productId,
            shopId: shopId,
            versionId: "1",
            inventoryQty: 0,
            latest: "true",
            category: "OTHERS",
            subCategory: "others",
            status: "new",
            count: product.count,
            productPrice: product.productPrice,
            productMrp: product.productMrp,
            unitOfMeasurment: product.unitOfMeasurment,
            discountPrice: product.discountPrice,
            productWastage: product.productWastage,
            productLabour: product.productLabour,
            productHsnCode: product.productHsnCode,
            purchasePrice: product.purchasePrice,
            productTax: product.productTax,
            imei1: product.imei1,
            imei2: product.imei2,
            taxId: product.taxId,
            productImageArray: product.productImageArray,
            taxIncExc: product.taxIncExc,
            productEANCode: product.productEANCode,
            productType: "product",
            ...productObj,
          };
          return [result, ...prev];
        }
      }
    });

    // if (filteredArr.length > 0) {
    //   updateExsistingProduct(tempProductId);
    // } else {
    //   const productObj = getTaxableValueAndTaxs(
    //     product,
    //     product.productPrice,
    //     product.count
    //   );
    //   if (product.isExist) {
    //     setAddedProducts((prev) => [
    //       {
    //         // ...product,
    //         // ...taxs,
    //         // totalTax: totalTaxPercentage,
    //         // taxMaster: seletedTax,
    //         // itemTotal: itemTotal,
    //         ...productObj,
    //         ...(product.taxIncExc
    //           ? { taxIncExc: product.taxIncExc }
    //           : product.productTax
    //           ? { taxIncExc: "inclusive" }
    //           : ""),
    //         count: product.count,
    //         productImageArray: product.productImageArray1
    //           ? product.productImageArray1.map((data) => data.S)
    //           : [],
    //       },
    //       ...prev,
    //     ]);
    //   }
    //else {
    //     const result = {
    //       productName: product.productName,
    //       addedDate: new Date().toISOString().substring(0, 10),
    //       productId: product.productId,
    //       shopId: shopId,
    //       versionId: "1",
    //       inventoryQty: 0,
    //       latest: "true",
    //       category: "Others",
    //       status: "new",
    //       count: product.count,
    //       productPrice: product.productPrice,
    //       productMrp: product.productMrp,
    //       unitOfMeasurment: product.unitOfMeasurment,
    //       discountPrice: product.discountPrice,
    //       productWastage: product.productWastage,
    //       productLabour: product.productLabour,
    //       productHsnCode: product.productHsnCode,
    //       purchasePrice: product.purchasePrice,
    //       productTax: product.productTax,
    //       imei1: product.imei1,
    //       imei2: product.imei2,
    //       taxId: product.taxId,
    //       productImageArray: [],
    //       taxIncExc: product.taxIncExc,
    //       productEANCode: product.productEANCode,
    //       productType: "product",
    //       ...productObj,
    //     };
    //     console.log("result", result);

    //     setAddedProducts((prevState) => [result, ...prevState]);
    //   }
    // }
    //setToInitialState("");
    setProductCode("");
  };

  const getRelatedProducts = (productId) => {
    const getProduct = products.find((i) => {
      return productId === i.productId;
    });
    const updateObj = { ...getProduct, count: 1, isExist: true };
    if (
      updateObj.taxId === "Select Tax" ||
      updateObj.taxIncExc === "Inclusive/Exclusive"
    ) {
      updateObj.taxId = undefined;
      updateObj.taxIncExc = undefined;
    }

    addItemHandler(updateObj, "fromScan");
  };

  const [cursor, setCursor] = useState(0);

  const hanldeKeydown = (e) => {
    if (e.keyCode === 38 && cursor > 0) {
      setCursor(cursor - 1);
    } else if (e.keyCode === 40 && cursor < productArray.length - 1) {
      setCursor(cursor + 1);
    }
    if (e.keyCode === 13) {
      let currentItem = productArray[cursor];
      if (currentItem !== undefined) {
        addItemHandler({ ...currentItem, count: 1, isExist: true }, "fromScan");
        setProductArray([]);
      }
    }
  };
  //day and date functions
  const month = [
    { long: "January", short: "JAN" },
    { long: "Febrary", short: "FEB" },
    { long: "March", short: "MAR" },
    { long: "April", short: "APR" },
    { long: "May", short: "MAY" },
    { long: "June", short: "JUN" },
    { long: "July", short: "JUL" },
    { long: "August", short: "AUG" },
    { long: "September", short: "SEP" },
    { long: "October", short: "OCT" },
    { long: "November", short: "NOV" },
    { long: "December", short: "DEC" },
  ];
  const weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const d = new Date();
  let Month = month[d.getMonth()].long;
  useEffect(() => {
    const fetchTaxsList = async (shopId) => {
      var res = await fetch(`${config.newApiKey}/taxMaster/taxMaster`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "x-api-key": `${config.newApiKey}`,
        },
        body: JSON.stringify({
          action: "fetchTaxmaster",
          shopId: shopId,
        }),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      setTaxList(res.data);
    };
    if (shopId) {
      fetchTaxsList(shopId);
    }
  }, [shopId]);

  // useEffect(() => {}, [summedOtherCharges]);
  useEffect(() => {
    function keydownHandler(event) {
      event.stopImmediatePropagation();
      if (event.altKey && event.keyCode == 83) {
        // alt + s >seach and add item for billing
        document.getElementById("searchItem").focus();
      } else if (event.altKey && event.keyCode == 75) {
        // alt + k >scan and add item for billing
        document.getElementById("scanItem").focus();
      } else if (event.altKey && event.keyCode == 66) {
        // bill generate (B)
        validate();
      } else if (event.altKey && event.keyCode == 80) {
        // Payment Mode (P)
        document.getElementById("cashamount").click();
      } else if (event.altKey && event.keyCode == 73) {
        // Add New Item (I)
        setAddNewItem(true);
      } else if (event.altKey && event.keyCode == 72) {
        // Hold Bill (H)
        document.getElementById("holdBtn").click();
      } else if (event.altKey && event.keyCode == 67) {
        // Enter customer details (C)
        document.getElementById("customerNumber").focus();
      } else if (event.altKey && event.keyCode == 68) {
        // Coupon Discount (O)
        setOffersModal(true);
      } else if (event.altKey && event.keyCode == 65) {
        // Delivery Address (A)
        setDeliveryAddr(true);
      } else if (event.altKey && event.keyCode == 64) {
        // OtherCharges (A)
        setotherCharges(true);
      } else if (event.altKey && event.keyCode == 78) {
        // Notes (N)
        setNotesModal(true);
      } else if (event.altKey && event.keyCode == 84) {
        setSettingModal(true);
      } else if (event.altKey && event.keyCode == 84) {
        setinvoicePage(true);
        setIsAdvanceSetting(false);
      }
    }
    document.addEventListener("keydown", keydownHandler, false);
    return () => {
      document.removeEventListener("keydown", keydownHandler, false);
    };
  }, [validate]);

  const reactToPrintContent = React.useCallback(() => {
    return printRef.current;
  }, [printRef.current]);

  const memorizedArray = (value) => {
    const cache = {};
    let result;

    if (cache[value] !== undefined) {
      result = cache[value];
    } else {
      const productValue = productsForSearch.find((i) => {
        return i?.eanCode?.toLowerCase() === value.toLowerCase();
      });
      if (productValue) {
        cache[value] = productValue;
        result = productValue;
      } else {
        result = "Not Found";
      }
    }
    return result;
  };

  useEffect(
    () => {
      if (productCode === "TBD") {
        alert("Update the EAN code");
      } else if (debouncedSearchEanCode && productCode !== "") {
        const product = memorizedArray(productCode);
        if (product?.id) {
          getRelatedProducts(product.id, "fromScan");
        } else if (product === "Not Found") {
          setItemNotFound(true);
        }
      }
    },
    [debouncedSearchEanCode, productCode] // Only call effect if debounced search term changes
  );

  const handleOnSelect = (item) => {
    getRelatedProducts(item.id);

    setTimeout(() => {
      clearSearch();
    }, 100);
  };

  const clearSearch = () => {
    const inputElement = document.querySelector(".clear-icon");
    inputElement.click();
  };

  const formatResult = (item) => {
    return (
      <div
        style={{
          padding: "1rem 0.75rem",
          borderBottom: "1px solid gray",
        }}
        key={item.value}
        role="listitem"
      >
        <div className="result-span">
          {item.name}
          {item.color && (
            <span
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
                backgroundColor: item.color,
                display: "inline-block",
                marginLeft: "0.5rem",
                marginRight: "0.5rem",
                verticalAlign: "middle",
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const amountValidator = (e) => {
    var id = e.target.id;
    var value = e.target.value;

    if (value.length > 8) {
      if (id == "cash") {
        setAmountPaidUsingCash(amountPaidUsingCash);
        return;
      } else if (id == "upi") {
        setAmountPaidUsingUpi(amountPaidUsingUpi);
        return;
      } else if (id == "card") {
        setAmountPaidUsingCard(amountPaidUsingCard);
        return;
      }
    }
    if (id == "cash") {
      setAmountPaidUsingCash(value);
    } else if (id == "upi") {
      setAmountPaidUsingUpi(value);
    } else if (id == "card") {
      setAmountPaidUsingCard(value);
    }
  };
  // const [enabled, setEnabled] = useState(false);
  // const [initialStep, setInitialStep] = useState(0);

  // useEffect(() => {
  //   setEnabled(true);
  // }, [shopDetails.loyaltyRatio]);

  // const onExit = () => {
  //   setEnabled(false);
  // };

  // const steps = [
  //   {
  //     element: "#loyaltyPoints",
  //     intro:
  //       "Click on loyalty points to view/redeem avilable loyality coupons to the customer",
  //     position: "left",
  //   },
  //   {
  //     element: "#otherCharges",
  //     intro: "Click on Other Charges  to add other charges price.",
  //     position: "left",
  //   },
  //   {
  //     element: "#discount",
  //     intro:
  //       "Click on that button to change the discount type flat to percentage or percentage to flat.",
  //     position: "left",
  //   },
  //   {
  //     element: "#totalAmount",
  //     intro:
  //       "Click on total to see subtotal, the other charges and reduction in billing.",
  //     position: "left",
  //   },
  //   {
  //     element: "#generateBill",
  //     intro:
  //       "Click on Generate bill to pay  by selecting the payment method or pay it later by selecting credit sale",
  //     position: "left",
  //   },
  // ];
  // const steps = [];
  // if (invoiceSettings.othercharges && billLineSettings.discount) {
  //   steps = [...available];
  // }

  const handleDraftClick = () => {
    setToInitialState();
    setAddedProducts([]);
    setCustomerName("");
    setCustomerPhoneNumber("");
    setBillShipAddress({
      billingAddress: "",
      shippingAddress: "",
    });
    setCurrentDraft(false);
    if (addedProducts.length === 0) {
      setCustomerName("");
      setCustomerPhoneNumber("");
    }
  };

  return (
    <Container style={{ background: "#f5f9fc", padding: 0 }} fluid>
      {/* {billPrint && (
        <div className="loading">
          <CircularProgress />
        </div>
      )} */}
      <div
        id="printThermal"
        style={{
          overflow: "hidden",
          height: "0px",
        }}
      >
        <div>
          {/* <ThermalTemplate
            ref={printRef}
            data={{
              settings: billLineSettings,
              products: addedProducts,
              result: {
                ...itemBillResult,
                billSubTotal: subTotal,
                invoiceNumber: billLineSettings.currentInvoiceNumber,
              },
              shopDetails: shopDetails,
              discountType: discountType,
              loyaltyPoints: loyaltyPoints,
              couponObj: appliedCoupon,
              loyaltyObj: appliedLoyalty,
              taxList: taxList,
              paymentMethod: [...new Set(paymentMethodForThermal)],
              billInput: {
                billTax: itemBillInput.billTax,
                billDiscount: itemBillInput.billDiscount,
                billPaid: itemBillResult.billPaidAmount,
                billAmountDue: itemBillResult.billAmountDue,
                notes: notes,
              },
              customerDetails: {
                customerPhoneNumber: customerPhoneNumber,
                customerName: customerName,
              },
              deliveryAddress: billShipAddress.shippingAddress,
            }} */}

          <InvoiceTemplate
            ref={printRef}
            data={{
              invoiceSettings: invoiceSettings,
              settings: billLineSettings,
              products: addedProducts,

              result: {
                ...itemBillResult,
                billSubTotal: subTotal,
                invoiceNumber: invoiceSettings.currentInvoiceNumber,
                invoicePrefixField:
                  shopDetails.shopType === "Restaurant"
                    ? billLineSettings.invoicePrefixField
                    : invoiceSettings.invoicePrefixtext,
              },
              shopDetails: shopDetails,
              discountType: discountType,
              loyaltyPoints: loyaltyPoints,
              couponObj: appliedCoupon,
              loyaltyObj: appliedLoyalty,
              taxList: taxList,
              paymentMethod: [...new Set(paymentMethodForThermal)],
              billInput: {
                billTax: itemBillInput.billTax,
                billDiscount: itemBillInput.billDiscount,
                billPaid: itemBillResult.billPaidAmount,
                billAmountDue: itemBillResult.billAmountDue,
                notes: notes,
              },
              customerDetails: {
                customerPhoneNumber: customerPhoneNumber,
                customerName: customerName,
              },
              deliveryAddress: billShipAddress.shippingAddress,
              billingAddress: billShipAddress.billingAddress,
            }}
          />
        </div>
      </div>

      <div className="invoice-generator-head">
        <div className="invoice-generator-head-btn1">
          <Button
            variant="text"
            onClick={() => props.history.push("/dashboard/overview")}
          >
            <DehazeIcon style={{ marginTop: -5 }} />
          </Button>
        </div>
        <div
          style={{ marginTop: 10, marginBottom: 10, display: "flex" }}
          className="invoice-generator-head-btn2"
        >
          <div
            className="invoice-generator-head-textfield"
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {console.log("productsForSearch1244", productsForSearch)}
            <ReactSearchAutocomplete
              className="searchItem"
              items={productsForSearch}
              onSelect={handleOnSelect}
              styling={{
                borderRadius: 4,
                boxShadow: "none",
                zIndex: 100,
              }}
              formatResult={formatResult}
              placeholder="Search items by typing product name or code"
              showIcon={true}
              showClear={true}
              maxResults={10}
              fuseOptions={{
                shouldSort: true,
                threshold: 0.6,
                location: 0,
                distance: 75,
                minMatchCharLength: 1,
                keys: ["name", "productCode"],
                includeMatches: false,
              }}
            />
          </div>{" "}
          <TextField
            id="scanItem"
            className="invoice-generator-head-textfield"
            placeholder="Place your cursor here and start scanning the product"
            value={productCode}
            onBlur={() => setProductArray([])}
            onChange={(e) => {
              setProductCode(e.target.value);
            }}
            style={{ marginLeft: 10 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <QrCodeScannerIcon />
                </InputAdornment>
              ),
            }}
            variant="outlined"
          />
        </div>
        <div className="invoice-generator-head-title" style={{ marginTop: 10 }}>
          <h4>{d.getDate() + ", " + Month + " " + d.getFullYear()} </h4>
        </div>

        <div className="signin">
          <Button variant="text"></Button>
        </div>
        {/* </div> */}
      </div>
      <div></div>

      <div
        style={{ background: "#f5f9fc" }}
        className="wholeContainer"
        onBlur={() => setProductArray([])}
      >
        <div className="twoContainer">
          <div className="leftContainer">
            <div className="invoice-generator-leftHead">
              <div className="invoice-generator-leftSubHead">
                <div
                  className={
                    currentDraft
                      ? "invoice-generator-leftSubHead-title1"
                      : "invoice-generator-leftSubHead-title2"
                  }
                >
                  <Button onClick={() => setCurrentDraft(true)} variant="text">
                    Current
                  </Button>
                </div>
                <div
                  className={
                    currentDraft
                      ? "invoice-generator-leftSubHead-title2"
                      : "invoice-generator-leftSubHead-title1"
                  }
                >
                  <Button onClick={handleDraftClick} variant="text">
                    Drafts({billDraft.length})
                  </Button>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="threeLinks">
                  {currentDraft && (
                    <>
                      <div>
                        <Button
                          variant="text"
                          className="invoice-generator-leftSubHead-link"
                          onClick={() => setShowShortkeys(true)}
                        >
                          <p> ShortCut Keys</p>
                        </Button>
                      </div>
                      <div>
                        <Button
                          variant="text"
                          className="invoice-generator-leftSubHead-link"
                          onClick={() => setAddNewItem(true)}
                        >
                          <p> + Add New Item</p>
                        </Button>
                      </div>
                      <div>
                        <Button
                          variant="text"
                          className="button-width invoice-generator-leftSubHead-link"
                          // onClick={() => setSettingModal(true)}
                          onClick={() => {
                            setinvoicePage(true);
                            setIsAdvanceSetting(true);
                          }}
                        >
                          <p>Advance Settings</p>
                        </Button>
                      </div>
                      <Button
                        variant="text"
                        className="button-width invoice-generator-leftSubHead-link"
                        onClick={() => {
                          setIsAdvanceSetting(false);
                          setinvoicePage(true);
                        }}
                      >
                        <p>Bill Settings</p>
                      </Button>
                      <div>
                        <Button
                          variant="text"
                          className="invoice-generator-leftSubHead-link"
                          onClick={() => {
                            setToInitialState();
                            setAddedProducts([]);
                            setCustomerName("");
                            setCustomerPhoneNumber("");
                            // setProdArr([]);
                            setBillShipAddress({
                              billingAddress: "",
                              shippingAddress: "",
                            });
                          }}
                        >
                          <p>Clear All</p>
                        </Button>
                      </div>
                    </>
                  )}
                  {!currentDraft && (
                    <div>
                      <Button
                        variant="text"
                        className="invoice-generator-leftSubHead-link"
                        onClick={() => handleDraftRemoveAll()}
                      >
                        <p>Remove All</p>
                      </Button>
                    </div>
                  )}
                </div>
                {currentDraft && (
                  <div style={{ display: "flex", background: "#ffff" }}>
                    {identifier && (
                      <TextField
                        id="UniqueIdentity"
                        size="small"
                        label={"Alias"}
                        variant="outlined"
                        style={{
                          marginRight: 6,
                          width: 150,
                        }}
                        value={uniqueId}
                        onChange={handleUniqueIdentityChange}
                        inputProps={{
                          maxLength: mobileNumberLimit,
                          pattern: "/[A-Za-z]{3}/",
                        }}
                        InputProps={{
                          startAdornment: <></>,
                        }}
                        placeholder={"Flat No or Block No"}
                        disabled={CustomerFoundFrom === "phoneNumber"}
                      />
                    )}
                    <div
                      className="customerDetails-number"
                      style={{
                        marginRight: 5,
                        position: "relative",
                        display: "flex",
                      }}
                    >
                      <TextField
                        id="alias"
                        ref={cutomerNumberRef}
                        size="small"
                        label={"Customer Number"}
                        variant="outlined"
                        disabled={CustomerFoundFrom === "alias"}
                        value={customerPhoneNumber}
                        onChange={handleCustomerNumberChange}
                        inputProps={{
                          maxLength: mobileNumberLimit,
                          pattern: "/[A-Za-z]{3}/",
                        }}
                        placeholder={"Customer Number"}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              {shopDetails.country.dialCode}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                    <div className="customerDetails-name">
                      <TextField
                        size="small"
                        label="Customer Name"
                        InputProps={{
                          startAdornment: <></>,
                        }}
                        variant="outlined"
                        disabled={CustomerFoundFrom === "alias"}
                        value={customerName}
                        placeholder="Customer Name"
                        onChange={(e) => {
                          setCustomerName(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginTop: "10px" }} className="table-wrapper">
              {!currentDraft && (
                <div
                  className="product-table"
                  style={{ background: "#feffff" }}
                >
                  {billDraft.length > 0 ? (
                    <Table>
                      <thead>
                        <tr>
                          <th>Created At</th>
                          <th>Mobile No.</th>
                          <th>Name</th>
                          <th>Item Count</th>
                          <th>Amount({country.CurrencySymbol})</th>
                          <th>Actions</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {billDraft.map((data) => (
                          <tr
                            key={data.billId}
                            style={{
                              background: "#feffff",
                            }}
                          >
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  textAlign: "left",
                                }}
                              >
                                <p>{data.billDate}</p>
                              </div>
                            </td>
                            <td style={{ textAlign: "left" }}>
                              <p>{data.customerPhoneNumber} </p>
                            </td>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  textAlign: "left",
                                }}
                              >
                                <p>{data.customerName}</p>
                              </div>
                            </td>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  textAlign: "left",
                                }}
                              >
                                <p>{data.numberOfItems}</p>
                              </div>
                            </td>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  textAlign: "left",
                                }}
                              >
                                <p>{data.billTotal}</p>
                              </div>
                            </td>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  textAlign: "left",
                                }}
                              >
                                <button
                                  className="holdBtn"
                                  style={{ width: "150px" }}
                                  onClick={() => moveDraftToCurrent(data)}
                                >
                                  Move to Billing
                                </button>
                              </div>
                            </td>
                            <td>
                              <div
                                style={{
                                  cursor: "pointer",
                                  textAlign: "left",
                                }}
                                onClick={() =>
                                  handleDeleteDraftBill(data.billId)
                                }
                              >
                                <DeleteIcon className="deleteIcon" />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  ) : (
                    <div className="noItemDiv">
                      <p className="noItemText" style={{ marginTop: 30 }}>
                        <>No Data to Display</>
                      </p>
                    </div>
                  )}
                </div>
              )}
              {currentDraft && (
                <>
                  <div
                    className="product-table"
                    style={{ background: "#feffff", position: "relative" }}
                  >
                    <div
                      className="product-table-header"
                      style={{
                        background: "#feffff",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ display: "flex" }}>
                        <div className="product-table-header-order">
                          <p>Order Items ({addedProducts.length})</p>
                        </div>
                        {/* <div className="product-table-header-line">
                          <p>|</p>
                        </div> */}
                        {/* <div className="product-table-header-invoice">
                          <p>
                            Invoice No: {invoiceSettings.invoicePrefixtext}
                            {invoiceSettings.currentInvoiceNumber}
                          </p>
                        </div> */}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "1rem",
                        }}
                      >
                        {outStanding > 0 && (
                          <div
                            style={{
                              marginRight: 7,
                              fontSize: "14px",
                              transition: "all 1s ease-in",
                            }}
                          >
                            <span style={{ marginRight: 7, fontSize: "14px" }}>
                              Outstanding
                            </span>
                            <span
                              style={{
                                fontSize: "14px",
                                textDecoration: "none",
                                cursor: "pointer",
                                color: "#CF0000",
                              }}
                            >
                              {customerDetailsLoading ? (
                                <Spinner
                                  variant="primary"
                                  animation="border"
                                  size="sm"
                                  style={{
                                    verticalAlign: "middle",
                                  }}
                                  className="confirmBillSpinner"
                                />
                              ) : (
                                currencyFormatter(outStanding)
                              )}
                            </span>
                          </div>
                        )}

                        {Math.ceil(
                          (new Date(shopDetails.loyaltyExpiryDate) -
                            new Date()) /
                            (1000 * 60 * 60 * 24)
                        ) > 0 &&
                          shopDetails.loyaltyRatio && (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                              id="loyaltyPoints"
                            >
                              <div style={{ marginRight: 7, fontSize: "14px" }}>
                                Loyalty Points
                              </div>
                              <div
                                style={{
                                  fontSize: "14px",
                                  textDecoration: "none",
                                  cursor: "pointer",
                                  color: "#CF0000",
                                }}
                                onClick={() => setLoyaltyModal(!loyaltyModal)}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span style={{ fontSize: "14px" }}>
                                    {customerDetailsLoading ? (
                                      <Spinner
                                        variant="primary"
                                        animation="border"
                                        size="sm"
                                        style={{
                                          verticalAlign: "middle",
                                        }}
                                        className="confirmBillSpinner"
                                      />
                                    ) : Object.keys(appliedLoyalty).length >
                                      0 ? (
                                      `${(
                                        parseFloat(loyaltyPoints) -
                                        parseFloat(
                                          appliedLoyalty.minLoyaltyPointsReq
                                        )
                                      ).toFixed(2)}...`
                                    ) : parseFloat(loyaltyPoints) ? (
                                      `${parseFloat(loyaltyPoints).toFixed(
                                        2
                                      )}...`
                                    ) : (
                                      0
                                    )}
                                  </span>
                                  <span style={{ marginTop: "-2px" }}>
                                    <FiChevronRight />
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    {addedProducts.length > 0 ? (
                      <Table responsive="md">
                        <thead>
                          <tr>
                            <th
                              style={{
                                verticalAlign: "middle",
                                fontWeight: "500",
                              }}
                            >
                              Item
                            </th>
                            {invoiceSettings.itemmrp && (
                              <th
                                style={{
                                  verticalAlign: "middle",
                                  fontWeight: "500",
                                }}
                              >
                                MRP
                              </th>
                            )}
                            <th
                              style={{
                                verticalAlign: "middle",
                                fontWeight: "500",
                              }}
                            >
                              Rate
                            </th>
                            <th
                              style={{
                                verticalAlign: "middle",
                                fontWeight: "500",
                              }}
                            >
                              Qty.
                            </th>
                            {/* {billLineSettings.itemWastage && (
                              <th
                                style={{
                                  verticalAlign: "middle",
                                  fontWeight: "500",
                                }}
                              >
                                Wast.(%)
                              </th>
                            )}
                            {billLineSettings.itemLabour && (
                              <th
                                style={{
                                  verticalAlign: "middle",
                                  fontWeight: "500",
                                }}
                              >
                                Labour(%)
                              </th>
                            )} */}
                            {invoiceSettings.hsncode && (
                              <th
                                style={{
                                  verticalAlign: "middle",
                                  fontWeight: "500",
                                }}
                              >
                                HSN
                              </th>
                            )}
                            {invoiceSettings.itemleveltax && (
                              <>
                                <th
                                  style={{
                                    verticalAlign: "middle",
                                    fontWeight: "500",
                                    textAlign: "center",
                                  }}
                                >
                                  Tax(%)
                                </th>
                                <th
                                  style={{
                                    verticalAlign: "middle",
                                    fontWeight: "500",
                                    width: "150px",
                                  }}
                                >
                                  Inclusive/Exclusive
                                </th>
                              </>
                            )}
                            <th
                              style={{
                                verticalAlign: "middle",
                                fontWeight: "500",
                              }}
                            >
                              Subtotal
                            </th>
                            <th
                              style={{
                                verticalAlign: "middle",
                                fontWeight: "500",
                              }}
                            ></th>
                          </tr>
                        </thead>
                        <tbody>
                          {addedProducts.map((data, index) => {
                            return (
                              <tr
                                key={data.productId}
                                className="align-items-center"
                                style={{
                                  background: "#feffff",
                                  verticalAlign: "middle",
                                }}
                              >
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                    position: "relative",
                                  }}
                                >
                                  <div className="productname-input">
                                    <p>{data.productName}</p>
                                    <h6>{data.unitOfMeasurment}</h6>
                                    {parseFloat(data.productPrice) >
                                      parseFloat(data.productMrp) && (
                                      <small
                                        style={{
                                          color: "rgb(240,66,9)",
                                          marginTop: "-0.5rem",
                                          textAlign: "left",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Selling price greater than mrp
                                      </small>
                                    )}
                                    {parseFloat(data.itemTotal) >
                                      parseFloat(data.productMrp) *
                                        parseFloat(data.count) && (
                                      <small
                                        style={{
                                          color: "rgb(240,66,9)",
                                          marginTop: "-0.3rem",
                                          textAlign: "left",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Sub Total greater than mrp
                                      </small>
                                    )}
                                  </div>
                                </td>
                                {invoiceSettings.itemmrp && (
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                      textAlign: "left",
                                    }}
                                  >
                                    <p>
                                      {data.productMrp
                                        ? parseFloat(data.productMrp).toFixed(2)
                                        : "0.00"}
                                    </p>
                                  </td>
                                )}
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <p style={{ textAlign: "left" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        borderBottom: "0.2px dashed #000000",
                                        width: "80px",
                                        backgroundColor: "white",
                                      }}
                                    >
                                      <input
                                        placeholder="Price"
                                        style={{
                                          width: "80px",
                                        }}
                                        value={data.productPrice}
                                        type="number"
                                        name="productPrice"
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(e) => {
                                          handleBillingInputChange(
                                            e.target.name,
                                            e.target.value,
                                            data,
                                            index
                                          );
                                        }}
                                      />
                                    </div>
                                    {/* {data.productPrice
                                      ? parseFloat(data.productPrice).toFixed(2)
                                      : "0.00"} */}
                                  </p>
                                  {invoiceSettings.itemdiscount && (
                                    <p>
                                      {data.discountPrice ? (
                                        data.discountType ? (
                                          data.discountType === "flat" ? (
                                            <p
                                              style={{
                                                width: "max-content",
                                                whiteSpace: "nowrap",
                                              }}
                                              className="ratecolor"
                                            >
                                              -
                                              {currencyFormatter(
                                                data.discountPrice
                                              )}
                                            </p>
                                          ) : (
                                            <p className="ratecolor">
                                              -{data.discountPrice}%
                                            </p>
                                          )
                                        ) : (
                                          <></>
                                        )
                                      ) : (
                                        <></>
                                      )}
                                    </p>
                                  )}
                                </td>
                                <td style={{ verticalAlign: "middle" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      borderBottom: "0.2px dashed #000000",
                                      width: "50px",
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <input
                                      placeholder="Qty"
                                      value={data.count}
                                      name="count"
                                      type="number"
                                      style={{
                                        width: 70,
                                      }}
                                      onWheel={(e) => e.target.blur()}
                                      onChange={(e) =>
                                        handleBillingInputChange(
                                          e.target.name,
                                          e.target.value,
                                          data,
                                          index
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                                {/* {billLineSettings.itemWastage && (
                                  <td style={{ verticalAlign: "middle" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div>
                                        {data.productWastage
                                          ? data.productWastage
                                          : "0%"}
                                      </div>
                                    </div>
                                  </td>
                                )} */}
                                {/* {billLineSettings.itemLabour && (
                                  <td style={{ verticalAlign: "middle" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div>
                                        {data.productLabour
                                          ? data.productLabour
                                          : "0%"}
                                      </div>
                                    </div>
                                  </td>
                                )} */}
                                {invoiceSettings.hsncode && (
                                  <td style={{ verticalAlign: "middle" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div>
                                        {data.productHsnCode ? (
                                          <>{data.productHsnCode}</>
                                        ) : (
                                          "Nil"
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                )}
                                {invoiceSettings.itemleveltax && (
                                  <td
                                    style={{
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    {data.taxId ? (
                                      taxList.map((tax) => {
                                        return (
                                          <span key={tax.taxId}>
                                            {tax.taxId === data.taxId &&
                                              tax.taxName}
                                          </span>
                                        );
                                      })
                                    ) : (
                                      //   <select
                                      //   name="taxId"
                                      //   style={{
                                      //     fontSize: 15,
                                      //     marginRight: 10,
                                      //     height: "32px",
                                      //     width: "150px",
                                      //   }}
                                      //   value={data.taxId}
                                      //   onChange={(e) =>
                                      //     handleBillingInputChange(
                                      //       e.target.name,
                                      //       e.target.value,
                                      //       data,
                                      //       index
                                      //     )
                                      //   }
                                      //   disabled={true}
                                      // >
                                      //   <option value={""}>Select Tax</option>
                                      //   {taxList.map((tax) => {
                                      //     return (
                                      //       <option
                                      //         key={tax.taxId}
                                      //         value={tax.taxId}
                                      //       >
                                      //         {tax.taxName}
                                      //       </option>
                                      //     );
                                      //   })}
                                      // </select>
                                      <span>{data.productTax}</span>
                                    )}
                                  </td>
                                )}
                                {invoiceSettings.itemleveltax && (
                                  <td style={{ verticalAlign: "middle" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {data?.taxIncExc !==
                                        "Inclusive/Exclusive" &&
                                        startCase(camelCase(data?.taxIncExc))}
                                      {/* <select
                                        name="taxIncExc"
                                        style={{
                                          fontSize: 15,
                                          marginRight: 10,
                                          height: "32px",
                                          width: "150px",
                                        }}
                                        value={data.taxIncExc}
                                        onChange={(e) =>
                                          handleBillingInputChange(
                                            e.target.name,
                                            e.target.value,
                                            data,
                                            index
                                          )
                                        }
                                        disabled={true}
                                      >
                                        <option value={""}>
                                          Select Inclusive/Exclusive
                                        </option>
                                        <option value={"inclusive"}>
                                          Inclusive
                                        </option>
                                        <option value={"exclusive"}>
                                          Exclusive
                                        </option>
                                      </select> */}
                                    </div>
                                  </td>
                                )}
                                <td style={{ verticalAlign: "middle" }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div>
                                      {data.count
                                        ? parseFloat(data.itemTotal).toFixed(2)
                                        : "0.00"}
                                    </div>
                                    {/* <div
                                        onClick={() =>
                                          deleteItemHandler(data.productId)
                                        }
                                      >
                                        {parseFloat(data.itemTotal) === 0 && (
                                          <small
                                            style={{
                                              color: "rgb(240,66,9)",
                                              marginTop: "-0.5rem",
                                              textAlign: "left",
                                              whiteSpace: "nowrap",
                                              marginLeft: "8px",
                                            }}
                                          >
                                            Delete item or Change Value
                                          </small>
                                        )}
                                      </div> */}
                                  </div>
                                </td>
                                {parseFloat(data.itemTotal) === 0 && (
                                  <td style={{ verticalAlign: "middle" }}>
                                    <div
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        deleteItemHandler(data.productId)
                                      }
                                    >
                                      <DeleteIcon style={{ color: "red" }} />
                                    </div>
                                  </td>
                                )}
                                {parseFloat(data.itemTotal) !== 0 && (
                                  <td style={{ verticalAlign: "middle" }}>
                                    <div
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        deleteItemHandler(data.productId)
                                      }
                                    >
                                      <DeleteIcon />
                                    </div>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    ) : (
                      <div className="noItemDiv">
                        <div className="noItemimg">
                          <img src={scanimg} width="50px" height="51px" />
                        </div>
                        <p className="noItemText" style={{ marginTop: 0 }}>
                          Start billing your items by scanning or add items from
                          inventory using search
                        </p>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            {currentDraft && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="holdCancelButton">
                  <div>
                    <button
                      id="holdBtn"
                      className="holdBtn"
                      onClick={() => handleHoldBill()}
                    >
                      Hold Bill
                    </button>
                  </div>
                  {invoiceSettings.deliveryaddress ? (
                    <div>
                      <p
                        className="delivery"
                        onClick={() => setDeliveryAddr(true)}
                        style={{ marginLeft: "11px" }}
                      >
                        <p>Delivery Address</p>
                      </p>
                    </div>
                  ) : (
                    <div style={{ marginLeft: "10px" }}></div>
                  )}
                  <div>
                    <p
                      className="coupon"
                      onClick={() => {
                        setOffersModal(true);
                        // fetchCoupons();
                      }}
                    >
                      <p>Coupon Disc.</p>
                    </p>
                  </div>
                  {invoiceSettings.notes && (
                    <div>
                      <p className="notes" onClick={() => setNotesModal(true)}>
                        <p>Notes</p>
                      </p>
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    position: "relative",
                  }}
                >
                  {invoiceSettings.othercharges && (
                    <div>
                      {invoiceSettings.othercharges && (
                        <div style={{ display: "flex" }} id="otherCharges">
                          <div
                            className="otherChargesNew"
                            onClick={() => {
                              setOtherChargesModal(true);
                              toggleTab(1);
                            }}
                            style={{
                              cursor: "pointer",
                              fontSize: "16px",
                              letterSpacing: "1px",
                              fontFamily: "sans-serif",
                            }}
                          >
                            + Other Charges
                          </div>
                          <div
                            className="otherChargesNewAmount"
                            onClick={() => setOtherChargesModal(true)}
                            style={{
                              cursor: "pointer",
                              fontFamily: "sans-serif",
                            }}
                          >
                            {summedOtherCharges}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {otherBillDetailsModal && (
                    <div ref={closeTotal} className="otherDetailsPopup">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>Subtotal</div>
                        <div>{currencyFormatter(subTotal)}</div>
                      </div>
                      <hr
                        style={{
                          borderTop: "dotted 1px",
                          marginTop: " 5px",
                          marginBottom: " 5px",
                        }}
                      />
                      <div className="addedCharges">
                        <div
                          style={{
                            display: "flex",
                            letterSpacing: "1px",
                            color: "#208441",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          <MdAddCircleOutline />{" "}
                          <span style={{ marginLeft: "4px" }}>
                            Other Charges
                          </span>
                        </div>
                        {billLineSettings.otherChargesField.map((data) => (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                            key={data.id}
                          >
                            <div
                              style={{
                                letterSpacing: "1px",
                                fontSize: "16px",
                                marginBottom: "7px",
                              }}
                            >
                              {data.name}
                            </div>
                            <div>
                              {parseFloat(data.price)
                                ? `${currencyFormatter(parseFloat(data.price))}`
                                : currencyFormatter(0)}
                            </div>
                          </div>
                        ))}
                        <hr
                          style={{
                            borderTop: "dotted 1px",
                            marginTop: " 5px",
                            marginBottom: " 5px",
                          }}
                        />
                        <div style={{ textAlign: "right" }}>
                          {summedOtherCharges}
                        </div>
                      </div>
                      <div className="deductedCharges">
                        <div
                          style={{
                            display: "flex",
                            letterSpacing: "1px",
                            color: "#CF0000",
                            alignItems: "center",
                            marginBottom: "3px",
                          }}
                        >
                          <AiOutlineMinusCircle />
                          <span style={{ marginLeft: "4px" }}>
                            Other Reductions
                          </span>{" "}
                        </div>
                        {Object.keys(appliedCoupon).length > 0 && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ fontSize: "16px" }}>Coupon</div>
                              <div
                                style={{
                                  fontSize: "10px",
                                  marginLeft: "5px",
                                }}
                              >
                                Discount ({appliedCoupon.promocode})
                              </div>
                              <div
                                className="appliedCouponClosure"
                                onClick={() => setAppliedCoupon({})}
                              >
                                <RiCloseCircleLine />
                              </div>
                            </div>
                            <div>
                              -
                              {currencyFormatter(
                                appliedCoupon.discountType === "flat"
                                  ? parseFloat(
                                      appliedCoupon.discountAmount
                                    ).toFixed(2)
                                  : (itemBillResult.billTotalAfterLoyalty *
                                      parseFloat(
                                        appliedCoupon.discountAmount
                                      )) /
                                      100
                              )}
                            </div>
                          </div>
                        )}
                        {invoiceSettings.adddiscount && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>Discount</div>
                            {itemBillInput.billDiscount ? (
                              <div style={{ display: "flex" }}>
                                <div>{discountType.billDiscountType}</div>
                                <div style={{ marginLeft: "5px" }}>
                                  {discountType.billDiscountType == "flat"
                                    ? country.CurrencySymbol
                                    : "%"}{" "}
                                  {itemBillInput.billDiscount}
                                </div>
                              </div>
                            ) : (
                              "00.0"
                            )}
                          </div>
                        )}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>Loyalty</div>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div
                              onClick={() => setAppliedLoyalty({})}
                              style={{ marginTop: "-6px" }}
                            >
                              x
                            </div>
                            <div>
                              {Object.keys(appliedLoyalty).length > 0
                                ? `${appliedLoyalty.minLoyaltyPointsReq} Points`
                                : "0 Points"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {invoiceSettings.othercharges && (
                    <div className="verticalLine"></div>
                  )}

                  {invoiceSettings.adddiscount && (
                    <div
                      style={{ display: "flex", alignItems: "center" }}
                      id="adddiscount"
                    >
                      <div
                        style={{
                          color: "#5194c6",
                          marginRight: "15px",
                          fontSize: "16px",
                          fontFamily: "sans-serif",
                          letterSpacing: "1px",
                        }}
                      >
                        Discount
                      </div>
                      <div>
                        <TextField
                          id="standard-basic"
                          className="discountNewTextfield"
                          onChange={(e) => handleInputChange(e)}
                          value={itemBillInput.billDiscount}
                          name="billDiscount"
                          type="number"
                          variant="outlined"
                          inputProps={{
                            style: {
                              padding: "0 !important",
                              fontSize: 13,
                              textAlign: "center",
                            },
                          }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <div
                                  value={discountType.billDiscountType}
                                  className="newDiscountTypeUI"
                                  onClick={() => {
                                    if (
                                      discountType.billDiscountType == "flat"
                                    ) {
                                      setDiscountType({
                                        ...discountType,
                                        billDiscountType: "percentage",
                                      });
                                    } else {
                                      setDiscountType({
                                        ...discountType,
                                        billDiscountType: "flat",
                                      });
                                    }
                                  }}
                                >
                                  {discountType.billDiscountType == "flat"
                                    ? country.CurrencySymbol
                                    : "%"}
                                </div>
                              </InputAdornment>
                            ),
                          }}
                        ></TextField>
                      </div>
                    </div>
                  )}
                  {invoiceSettings.adddiscount && (
                    <div className="verticalLine"></div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "200px",
                    }}
                  >
                    <div
                      style={{
                        marginRight: "15px",
                        fontSize: "16px",
                        fontFamily: "sans-serif",
                        letterSpacing: "1px",
                      }}
                    >
                      Subtotal
                    </div>
                    <div
                      style={{
                        fontSize: "16px",
                        letterSpacing: "1px",
                        fontFamily: "sans-serif",
                      }}
                    >
                      {currencyFormatter(subTotal)}
                    </div>
                  </div>
                  <div className="verticalLine"></div>

                  <div
                    ref={totalButton}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      width: "200px",
                    }}
                    onClick={() =>
                      setOtherBillDetailsModal(!otherBillDetailsModal)
                    }
                    id="totalAmount"
                  >
                    <div
                      style={{
                        marginRight: "15px",
                        color: "#208441",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "16px",
                        letterSpacing: "1px",
                      }}
                    >
                      <img
                        src={DoubleArrow}
                        className={
                          otherBillDetailsModal
                            ? "rotateCssWhenOpen"
                            : "rotateCssWhenClose"
                        }
                      />
                      Total
                    </div>
                    <div
                      style={{
                        color: "#208441",
                        fontSize: "16px",
                        letterSpacing: "1px",
                      }}
                    >
                      {currencyFormatter(
                        parseFloat(itemBillResult.billFinalTotal)
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {currentDraft && (
              <div style={{ textAlign: "right" }}>
                <button
                  className="generatebillBtn"
                  onClick={() => {
                    validate();
                  }}
                  id="generateBill"
                >
                  GENERATE BILL
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        show={otherChargesModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setOtherChargesModal(false)}
        backdrop="static"
      >
        <div style={{ paddingTop: "10px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingLeft: "20px",
              paddingRight: "20px",
            }}
          >
            {toggleState === 2 && (
              <div
                className={
                  toggleState === 1
                    ? "B-tabs2 B-tabsButton2 B-active-tabs2"
                    : "B-tabs2 B-tabsButton2"
                }
                style={{ color: "#EF4667" }}
                onClick={() => {
                  toggleTab(1);
                  if (billLineSettings.gst === "") {
                    return alert("Please enter GST");
                  } else if (billLineSettings.igst === "") {
                    return alert("Please select IGST");
                  } else if (billLineSettings.cess === "") {
                    return alert("Please select CESS");
                  } else if (billLineSettings.additionalcess === "") {
                    return alert("Please select Additional CESS");
                  }

                  toggleTab(1);
                  updateSettings().then((data) => {
                    setBillLineSettings(data.Attributes.settings);
                    dispatch({
                      type: "SET_SETTINGS",
                      payload: data.Attributes.settings,
                    });
                  });
                }}
              >
                Other Charges
              </div>
            )}

            {toggleState === 1 && (
              <div
                className={
                  toggleState === 1
                    ? "B-tabs2 B-tabsButton2 B-active-tabs2"
                    : "B-tabs2 B-tabsButton2"
                }
                style={{ color: "#EF4667" }}
                onClick={() => {
                  toggleTab(1);
                }}
              >
                Other Charges
              </div>
            )}

            <div>
              <div
                className={
                  toggleState === 2
                    ? "B-tabs2 B-tabsButton2 B-active-tabs2"
                    : "B-tabs2 B-tabsButton2"
                }
                onClick={() => {
                  toggleTab(2);
                }}
              >
                <div
                  style={{
                    color: "white",
                    background: "#5194c6",
                    fontSize: "13px",
                    padding: "5px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Add charge <MdAddCircleOutline />
                </div>
              </div>
            </div>
            {toggleState === 1 ? (
              <div
                style={{ color: "black", cursor: "pointer" }}
                onClick={() => {
                  addOtherCharges();
                  setOtherChargesModal(false);
                }}
              >
                x
              </div>
            ) : (
              <div
                style={{ color: "red", cursor: "pointer" }}
                onClick={() => {
                  addOtherCharges();
                  setOtherChargesModal(false);
                  if (billLineSettings.gst === "") {
                    return alert("Please enter GST");
                  } else if (billLineSettings.igst === "") {
                    return alert("Please select IGST");
                  } else if (billLineSettings.cess === "") {
                    return alert("Please select CESS");
                  } else if (billLineSettings.additionalcess === "") {
                    return alert("Please select Additional CESS");
                  }
                  // setSettingModal(false);

                  updateSettings().then((data) => {
                    setBillLineSettings(data.Attributes.settings);
                    dispatch({
                      type: "SET_SETTINGS",
                      payload: data.Attributes.settings,
                    });
                  });
                }}
              >
                x
              </div>
            )}
          </div>
          <div className="B-content-tabs" style={{ margin: "10px" }}>
            <div
              className={
                toggleState === 1 ? "B-content  B-active-content" : "B-content"
              }
            >
              <hr style={{ fontSize: "1px" }}></hr>
              <div>
                {invoiceSettings.othercharges &&
                  billLineSettings.otherChargesField.map((data) => (
                    <div
                      className="rightBottomContainer-customcharge"
                      key={data.id}
                    >
                      <p>
                        {data.name.charAt(0).toUpperCase() + data.name.slice(1)}
                      </p>
                      <TextField
                        type="number"
                        placeholder={`${country.CurrencySymbol}0.00`}
                        value={data.price}
                        onChange={(event) =>
                          setBillLineSettings({
                            ...billLineSettings,
                            otherChargesField: [
                              ...billLineSettings.otherChargesField.map(
                                (arrData) => {
                                  if (arrData.id === data.id) {
                                    if (event.target.value === "") {
                                      return {
                                        ...arrData,
                                        price: "",
                                      };
                                    }
                                    return {
                                      ...arrData,
                                      price: event.target.value,
                                    };
                                  } else {
                                    return arrData;
                                  }
                                }
                              ),
                            ],
                          })
                        }
                        style={{
                          height: 16,
                          width: 50,
                          marginTop: 1,
                          padding: 0,
                          textAlign: "left",
                        }}
                        inputProps={{
                          style: {
                            padding: 0,
                            fontSize: 13,
                            textAlign: "left",
                          },
                        }}
                      ></TextField>
                    </div>
                  ))}
                <div style={{ textAlign: "right" }}>
                  <button
                    className="otherChargesAddButton"
                    onClick={() => {
                      addOtherCharges();
                      setOtherChargesModal(false);
                    }}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
            <div
              className={
                toggleState === 2 ? "B-content  B-active-content" : "B-content"
              }
            >
              <hr style={{ fontSize: "1px" }}></hr>
              {invoiceSettings.othercharges && (
                <div style={{ marginLeft: "20px" }}>
                  <div style={{ marginBottom: "10px" }}>
                    <input
                      placeholder="Enter charge name"
                      onChange={(e) => setChargesName(e.target.value)}
                      value={chargesName}
                    />
                    <Button
                      style={{ marginLeft: "3%", marginTop: -3 }}
                      size="sm"
                      onClick={() => {
                        if (chargesName === "") {
                          alert("Field should not be empty");
                          return;
                        }
                        chargesAddButtonHandler();
                      }}
                    >
                      Add
                    </Button>
                  </div>

                  {billLineSettings.otherChargesField.map((data) => (
                    <div
                      key={data.id}
                      style={{
                        padding: "8px",
                        float: "left",
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          border: "2px solid black",
                          padding: "2px 10px 2px 10px",
                          borderRadius: "17px",
                        }}
                      >
                        <label>{data.name}</label>
                        <HighlightOffIcon
                          style={{
                            marginLeft: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => deleteChargeHandler(data.id)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        show={notesModal}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setNotesModal(false)}
      >
        <Modal.Header>
          <div>
            <h4 style={{ color: "#EF4667", marginBottom: 0 }}>NOTES</h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            as="textarea"
            rows={5}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
          <p
            style={{
              textAlign: "right",
              fontSize: 10,
              color: "#3f3f3f",
              marginBottom: 0,
              marginTop: 5,
            }}
          >
            Char count {notes.length}/250
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="cancelButton"
            onClick={() => {
              setNotesModal(false);
              setNotes("");
            }}
          >
            Cancel
          </button>
          <button
            className="addAddrButton"
            onClick={() => {
              setNotesModal(false);
            }}
          >
            ADD NOTES
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={deliveryAddr}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDeliveryAddr(false)}
      >
        <Modal.Header>
          <div>
            <h4 style={{ color: "#EF4667", marginBottom: 0 }}>
              Delivery Address
            </h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-6" style={{ paddingRight: 7 }}>
              <p>Billing Address</p>
              <Form.Control
                as="textarea"
                rows={5}
                value={billShipAddress.billingAddress}
                placeholder="Enter billing address"
                onChange={(e) => {
                  if (addressCheckBox) {
                    setBillShipAddress({
                      ...billShipAddress,
                      billingAddress: e.target.value,
                      shippingAddress: e.target.value,
                    });
                    return;
                  }
                  setBillShipAddress({
                    ...billShipAddress,
                    billingAddress: e.target.value,
                  });
                }}
              />
            </div>
            <div className="col-6" style={{ paddingLeft: 7 }}>
              <p>Shipping Address</p>
              <Form.Control
                as="textarea"
                rows={5}
                placeholder="Enter shipping address"
                value={billShipAddress.shippingAddress}
                disabled={addressCheckBox}
                onChange={(e) => {
                  setBillShipAddress({
                    ...billShipAddress,
                    shippingAddress: e.target.value,
                  });
                }}
              />
              <Checkbox
                checked={addressCheckBox}
                onChange={() => {
                  setBillShipAddress({
                    ...billShipAddress,
                    shippingAddress: billShipAddress.billingAddress,
                  });
                  setAddressCheckBox(!addressCheckBox);
                }}
              />
              <p
                style={{
                  display: "inline-block",
                  marginBottom: 0,
                  fontSize: 14,
                }}
              >
                Same as Billing Address
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="cancelButton"
            onClick={() => {
              setDeliveryAddr(false);
              setBillShipAddress({
                billingAddress: "",
                shippingAddress: "",
              });
            }}
          >
            Cancel
          </button>
          <button
            className="addAddrButton"
            onClick={() => {
              setDeliveryAddr(false);
            }}
          >
            ADD ADDRESS
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={otherCharges}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setotherCharges(false)}
      >
        <div
          style={{
            borderBottom: "2px solid black",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div>
            <div style={{ margin: "15px", float: "left" }}>
              <p
                style={{
                  fontSize: "13px",
                  color: "#ef4667",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setAddExtraChargeField(!addExtraChargeField);
                  // setSettingModal(true);
                }}
              >
                Click here to create custom charges...
              </p>
            </div>
            <div>
              {/* <Checkbox
                      style={{ float: "right", margin: "15px" }}
                      checked={invoiceSettings.othercharges}
                      onChange={checkBoxHandler}
                      value="otherCharges"
                    /> */}
              {/* <Button
                // ref={saveOthercharges}

                className="addAddrButton"
                style={{ display: "none", float: "right", margin: "15px" }}
                onClick={() => {
                  if (billLineSettings.gst === "") {
                    return alert("Please enter GST");
                  } else if (billLineSettings.igst === "") {
                    return alert("Please select IGST");
                  } else if (billLineSettings.cess === "") {
                    return alert("Please select CESS");
                  } else if (billLineSettings.additionalcess === "") {
                    return alert("Please select Additional CESS");
                  }
                  setSettingModal(false);
                  updateSettings().then((data) => {
                    setBillLineSettings(data.Attributes.settings);
                    dispatch({
                      type: "SET_SETTINGS",
                      payload: data.Attributes.settings,
                    });
                  });
                }}
              >
                save
              </Button> */}
            </div>
          </div>
        </div>
      </Modal>

      <AntdModal
        centered
        open={billConfirm}
        closable={false}
        footer={false}
        width={700}
        maskStyle={{
          backgroundColor: "rgb(0 0 0 / 26%)",
        }}
      >
        <div className="multiplePaymentMainContainer">
          <div className="totalAmountContainer">
            <div className="totalAmountContainerInnerContainer">
              <div>Total</div>
              <div>Amount</div>
              <div style={{ color: "#208441" }}>
                {parseFloat(itemBillResult.billFinalTotal).toFixed(2)}
              </div>
              <div
                style={{
                  position: "absolute",
                  bottom: "0",
                  left: "0",
                  margin: "20px",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "17px", fontWeight: "400" }}>
                    Paid Amount
                  </div>
                  <div
                    style={{
                      fontSize: "17px",
                      fontWeight: "400",
                      color: "#208441",
                    }}
                  >
                    {itemBillResult.billPaidAmount
                      ? itemBillResult.billPaidAmount.toFixed("2")
                      : "0.0"}
                  </div>
                </div>
              </div>
              <div style={{ position: "absolute", bottom: "0", right: "0" }}>
                <div style={{ margin: "20px" }}>
                  <div className="balanceAmountNewTitle">
                    {itemBillResult.billAmountDue > 0 ? (
                      "Balance"
                    ) : itemBillResult.billAmountDue <= 0 ? (
                      "Remaining"
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="balanceAmountNewAmount">
                    {itemBillResult.billAmountDue > 0 ? (
                      <>
                        -
                        {currencyFormatter(
                          Math.abs(itemBillResult.billAmountDue)
                        )}
                      </>
                    ) : itemBillResult.billAmountDue <= 0 ? (
                      <>
                        {currencyFormatter(
                          Math.abs(itemBillResult.billAmountDue).toFixed("2")
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>{" "}
                </div>{" "}
              </div>
            </div>
          </div>

          <div className="paymentTextfieldsContainer">
            <div
              className={
                billLoading
                  ? "paymentTextfieldsClosureDisable"
                  : "paymentTextfieldsClosure"
              }
              disabled={billLoading}
              onClick={() => {
                setBillConfirm(false);
                setCreditSale(false);
              }}
            >
              <MdOutlineClose />
            </div>
            <div className="paymentTextfieldsTitle">Payment Methods</div>
            <div className="textFieldsContainer">
              <div className="cashFieldSection">
                <TextField
                  onChange={(e) => {
                    if (e.target.value != "") {
                      paymentMethodForThermal.push("cash");
                    } else {
                      var temp = paymentMethodForThermal.filter((data) => {
                        return data != "cash";
                      });
                      setPaymentMethodForThermal(temp);
                    }
                    amountValidator(e);
                  }}
                  size="small"
                  variant="outlined"
                  label="Cash Payment"
                  placeholder="Enter Cash Amount"
                  value={amountPaidUsingCash}
                  name="billPaidAmount"
                  type="number"
                  fullWidth={true}
                  disabled={creditSale}
                  id="cash"
                  inputProps={{
                    step: ".01",
                    maxLength: 8,
                    pattern: "/[A-Za-z]{3}/",
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <BsCash style={{ fontSize: "45px" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="upiFieldSection">
                <TextField
                  onChange={(e) => {
                    amountValidator(e);
                    if (e.target.value != "") {
                      paymentMethodForThermal.push("upi");
                    } else {
                      var temp = paymentMethodForThermal.filter((data) => {
                        return data != "upi";
                      });
                      setPaymentMethodForThermal(temp);
                    }
                    // handleInputChange(e);
                  }}
                  value={amountPaidUsingUpi}
                  name="billPaidAmount"
                  type="number"
                  placeholder="Enter UPI Amount"
                  disabled={creditSale}
                  id="upi"
                  size="small"
                  variant="outlined"
                  label="UPI Payment"
                  fullWidth={true}
                  style={
                    {
                      // width: "255px",
                    }
                  }
                  inputProps={{
                    maxLength: 8,
                    pattern: "/[A-Za-z]{3}/",
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <img src={UPISVG} width={50} height={50} />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="cardFieldSection">
                <TextField
                  onChange={(e) => {
                    amountValidator(e);
                    if (e.target.value != "") {
                      paymentMethodForThermal.push("card");
                    } else {
                      var temp = paymentMethodForThermal.filter((data) => {
                        return data != "card";
                      });
                      setPaymentMethodForThermal(temp);
                    }
                  }}
                  id="card"
                  value={amountPaidUsingCard}
                  name="billPaidAmount"
                  placeholder="Enter Card Amount"
                  disabled={creditSale}
                  size="small"
                  variant="outlined"
                  label="Card Payment"
                  fullWidth={true}
                  style={{
                    borderRadius: "10px !important",
                  }}
                  type="number"
                  inputProps={{
                    maxLength: 8,
                    pattern: "/[A-Za-z]{3}/",
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <BsCreditCard2Back style={{ fontSize: "45px" }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <div className="chooseCardTypeSection">
                  <div>
                    <select
                      onChange={(e) => setCardType(e.target.value)}
                      disabled={creditSale}
                      className="selectOfChooseCardType"
                    >
                      <option value="">Card type</option>
                      <option value="visa">Visa</option>
                      <option value="masterCard">Master Card</option>
                      <option value="platinum">Rupay</option>
                    </select>
                  </div>
                  <div>
                    <input
                      style={{ width: "176px" }}
                      className="inputOfChooseCardType"
                      disabled={creditSale}
                      type="number"
                      placeholder="Enter last 4 digits"
                      value={cardNumber}
                      onChange={(e) => setCardNumber(e.target.value)}
                      maxLength={4}
                    />
                  </div>
                </div>
              </div>
              <div className="creditFieldSection">
                <div>
                  {" "}
                  <Divider
                    style={{
                      borderTopWidth: "2px",
                      borderColor: "gray",
                      fontSize: "14px",
                      color: "gray",
                    }}
                  >
                    Or Pay It Later By Credit Sale
                  </Divider>
                </div>
                <div
                  style={
                    customerPhoneNumber === ""
                      ? { textAlign: "center", cursor: "not-allowed" }
                      : { textAlign: "center" }
                  }
                >
                  {/* <input
                    type="checkbox"
                    onClick={() => {
                      setCreditSale(!creditSale);
                    }}
                  /> */}
                  <input
                    id="credit-sales"
                    type="radio"
                    style={
                      customerPhoneNumber === ""
                        ? { cursor: "not-allowed", marginRight: "4px" }
                        : { marginRight: "4px" }
                    }
                    onClick={() => {
                      setCreditSale(!creditSale);
                    }}
                    checked={creditSale}
                    disabled={customerPhoneNumber === ""}
                  />
                  <label
                    style={
                      customerPhoneNumber === ""
                        ? { cursor: "not-allowed" }
                        : {}
                    }
                    for={"credit-sales"}
                  >
                    Credit Sale
                  </label>
                </div>
              </div>
              <div>
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                  <Typography.Text type="danger">
                    {shopDetails.smsPackage === "yes" ? (
                      shopDetails.smsCount <= 0 ? (
                        <NavLink
                          style={{
                            color: "red",
                            textDecoration: "underline",
                          }}
                          to="/dashboard/plan-and-pricing"
                        >
                          You consumed all the SMS, Recharge again
                        </NavLink>
                      ) : (
                        ""
                      )
                    ) : (
                      <>
                        <NavLink
                          style={{
                            color: "red",
                            textDecoration: "underline",
                          }}
                          to="/dashboard/plan-and-pricing"
                        >
                          Activate
                        </NavLink>{" "}
                        <Typography.Text>
                          the SMS package for SMS
                        </Typography.Text>
                      </>
                    )}
                  </Typography.Text>

                  <Space direction="horizontal">
                    <AntdButton
                      size="large"
                      type="primary"
                      style={{
                        width: 140,
                      }}
                      disabled={billLoading}
                      onClick={() => {
                        newValidator();
                      }}
                      loading={!!(!isSms && billLoading)}
                    >
                      Print
                    </AntdButton>
                    <AntdButton
                      type="primary"
                      disabled={
                        billLoading ||
                        shopDetails.smsPackage === "no" ||
                        !shopDetails.smsPackage ||
                        shopDetails.smsCount <= 0
                      }
                      onClick={() => {
                        if (!customerPhoneNumber || !customerName) {
                          alert("Please enter customer details for Sms");
                          return;
                        }
                        newValidator();
                        setIsSms(true);
                      }}
                      style={{
                        width: 140,
                      }}
                      size="large"
                      loading={!!(isSms && billLoading)}
                    >
                      Print + SMS
                    </AntdButton>
                    <ReactToPrint
                      trigger={() => {
                        return (
                          <button
                            ref={confirmRef}
                            style={{
                              visibility: "hidden",
                              width: 1,
                              maxWidth: 1,
                              padding: 0,
                              height: 1,
                            }}
                            // disabled={billLoading}
                            className="confirmBillNew"
                          >
                            Confirm
                          </button>
                        );
                      }}
                      content={reactToPrintContent}
                      onAfterPrint={() => {
                        setBillConfirm(false);
                        setBillLoading(false);
                        setNotes("");
                      }}

                      // onBeforePrint={handleBeforePrint}
                    />
                  </Space>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AntdModal>

      <Modal
        show={itemNotFound}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setItemNotFound(false);
          setProductCode("");
        }}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div style={{ textAlign: "center", padding: 0 }}>
            <div className="height12"></div>
            <div className="height12"></div>
            <img src={modalimg} width="30px" height="24px" />
            <div className="height12"></div>
            <p className="notfoundtext">Item Not Found</p>
            <p className="scannedtext">Scanned Item Code : {productCode}</p>
            <p className="addItemalert">
              Do you want to add this item to your inventory
            </p>
            <div className="height12"></div>
            <div className="height12"></div>
            <div className="rowButton">
              <button
                onClick={() => {
                  setItemNotFound(false);
                  setProductCode("");
                  setItemBillInput({
                    ...itemBillInput,
                    itemEANCode: "",
                  });
                }}
                className="rightborder"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setAddNewItem(true);
                  setItemNotFound(false);
                }}
              >
                Add Item
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showShortkeys}
        dialogClassName="custom-modal"
        onHide={() => setShowShortkeys(false)}
      >
        <Modal.Header closeButton>
          <div>
            <h3 style={{ color: "#EF4667" }}>ShortCut Keys</h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="shortCutRow">
            <div className="shortCutCol">
              <div>
                <h4 className="shortkeyHeading">DashBoard</h4>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Ctrl</span> + F1 - Dashboard
                </h6>
                <hr />
                <h4 className="shortkeyHeading">Billing</h4>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Ctrl</span> + F2 - Billing
                </h6>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Alt</span> + S - Search and
                  Add Item
                </h6>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Alt</span> + K - Scan
                  Product
                </h6>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Alt</span> + G - Generate
                  Bill
                </h6>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Alt</span> + P - Payment
                  Mode
                </h6>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Alt</span> + I - Add New
                  Item
                </h6>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Alt</span> + H - Hold Bill
                </h6>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Alt</span> + C - Enter
                  Customer details
                </h6>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Alt</span> + D - Coupon
                  Discount
                </h6>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Alt</span> + A - Delivery
                  Address
                </h6>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Alt</span> + N - Notes
                </h6>
                <h6 className="shortkeyStyle">
                  <span className="specialKeyStyle">Alt</span> + T - Advance
                  Settings
                </h6>
              </div>
              <hr />
            </div>
            <div className="shortCutCol">
              <h4 className="shortkeyHeading">Shop Items</h4>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Ctrl</span> + F3 - Shop Items
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + N - Add
                Item/product
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + U - Add Excel
                upload for product
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + T - Tax Master
              </h6>
              <hr />
              <h4 className="shortkeyHeading">Reports</h4>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Ctrl</span> + F5 - Reports
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + D - Download
                Report
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + S - Search
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + E - Export
              </h6>
              <hr />
              <h4 className="shortkeyHeading">Stock Value Report</h4>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Ctrl</span> + F6 - Stock Value
                Report
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + S - Search
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + E - Export
              </h6>
              <hr />
            </div>
            <div className="shortCutCol">
              <h4 className="shortkeyHeading">Loyalty Points</h4>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Ctrl</span> + F7 - Loyalty
                Points
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + A - Add Point
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + R - Redeem Coupon
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + H - Points
                History
              </h6>
              <hr />
              <h4 className="shortkeyHeading">Customer Management</h4>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Ctrl</span> + F8 - Customer
                Management
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + S - Search
                Customer
              </h6>
              <hr />
              <h4 className="shortkeyHeading">Vendor Management</h4>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Ctrl</span> + F9 - Vendor
                Management
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + A - Add Vender
              </h6>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Alt</span> + T - Download tax
                input report
              </h6>
              <hr />
              <h4 className="shortkeyHeading">Employee Access</h4>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Ctrl</span> + F10 - Employee
                Access
              </h6>
              <hr />
              <h4 className="shortkeyHeading">Settings</h4>
              <h6 className="shortkeyStyle">
                <span className="specialKeyStyle">Ctrl</span> + F11 - Settings
              </h6>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={addNewItem}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        onHide={() => setAddNewItem(false)}
      >
        <Modal.Header closeButton>
          <div>
            <h3 style={{ color: "#EF4667" }}>Add Item to Bill</h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              <div className="col-5">
                <Form.Label>Item Name *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Item Name"
                  name="productName"
                  value={itemBillInput.itemName}
                  onChange={(e) => {
                    setItemBillInput({
                      ...itemBillInput,
                      itemName: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="col-7">
                <div className="row">
                  <div className="col-6">
                    <label>Selling Price *</label>
                    <Form.Control
                      onWheel={(e) => e.target.blur()}
                      placeholder="Selling Price"
                      name="productPrice"
                      type="number"
                      value={itemBillInput.itemRate}
                      onChange={(e) => {
                        setItemBillInput({
                          ...itemBillInput,
                          itemRate: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div className="col-6">
                    <label>Product MRP </label>
                    <Form.Control
                      onWheel={(e) => e.target.blur()}
                      placeholder="MRP"
                      name="productMrp"
                      type="number"
                      onChange={(e) => {
                        setItemBillInput({
                          ...itemBillInput,
                          itemMRP: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div style={{ height: 15 }}></div>
            <div className="row">
              <div className="col-5">
                <Form.Label>Item Barcode</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Eg.18090898009"
                  name="productEANCode"
                  value={itemBillInput.itemEANCode}
                  disabled={productCode ? true : false}
                  onChange={(e) =>
                    setItemBillInput({
                      ...itemBillInput,
                      itemEANCode: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-7">
                <div className="row">
                  <div className="col-6">
                    <label>Purchase Price </label>
                    <Form.Control
                      onWheel={(e) => e.target.blur()}
                      placeholder="Purchase Price"
                      name="purchasePrice"
                      type="number"
                      value={itemBillInput.itemPurchasePrice}
                      onChange={(e) =>
                        setItemBillInput({
                          ...itemBillInput,
                          itemPurchasePrice: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-6">
                    <label>Quantity *</label>
                    <Form.Control
                      onWheel={(e) => e.target.blur()}
                      placeholder="Quantity"
                      name="inventoryQty"
                      type="number"
                      value={itemBillInput.itemQuantity}
                      onChange={(e) =>
                        setItemBillInput({
                          ...itemBillInput,
                          itemQuantity: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div style={{ height: 15 }}></div>
            <label>Unit(s)</label>
            <div className="row">
              <div className="col-5">
                <div className="row">
                  <div className="col-8" style={{ paddingRight: 0 }}>
                    <Form.Control
                      onWheel={(e) => e.target.blur()}
                      placeholder="Unit Per Piece"
                      name="measurementValue"
                      type="number"
                      value={itemBillInput.measurmentValue}
                      onChange={(e) =>
                        setItemBillInput({
                          ...itemBillInput,
                          measurmentValue: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-4" style={{ paddingLeft: 0 }}>
                    <Form.Control
                      as="select"
                      style={{ backgroundColor: "#e5e5e5" }}
                      name="measurementUnit"
                      value={itemBillInput.measurmentUnit}
                      onChange={(e) =>
                        setItemBillInput({
                          ...itemBillInput,
                          measurmentUnit: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled>
                        Unit
                      </option>
                      {UNIT.map((data) => (
                        <option key={data} value={data}>
                          {data}
                        </option>
                      ))}
                    </Form.Control>
                  </div>
                </div>
              </div>
              <div className="col-7">
                <div className="row">
                  <div
                    className="col-6"
                    style={{
                      marginTop: "-30px",
                    }}
                  >
                    <label>Tax</label>
                    <Form.Control
                      as="select"
                      name="taxId"
                      value={itemBillInput.taxId}
                      onChange={(e) =>
                        setItemBillInput({
                          ...itemBillInput,
                          taxId: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Select Tax
                      </option>
                      {taxList.map((data) => (
                        <option key={data.taxId} value={data.taxId}>
                          {data.taxName}
                        </option>
                      ))}
                    </Form.Control>
                  </div>
                  <div
                    className="col-6"
                    style={{
                      marginTop: "-30px",
                    }}
                  >
                    <label>Inclusive/Exclusive</label>
                    <Form.Control
                      as="select"
                      name="taxIncExc"
                      value={itemBillInput.taxIncExc}
                      onChange={(e) =>
                        setItemBillInput({
                          ...itemBillInput,
                          taxIncExc: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Inclusive/Exclusive
                      </option>
                      <option value="inclusive">Inclusive</option>
                      <option value="exclusive">Exclusive</option>
                    </Form.Control>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="cancelButton"
            onClick={() => {
              setAddNewItem(false);
              setToInitialState();
            }}
          >
            Cancel
          </button>
          <button
            className="addAddrButton"
            onClick={() => {
              const product = {
                productName: itemBillInput.itemName,
                productPrice: itemBillInput.itemRate,
                productMrp: itemBillInput.itemMRP,
                unitOfMeasurment:
                  itemBillInput.measurmentValue +
                  " " +
                  itemBillInput.measurmentUnit,
                discountType: discountType.itemDiscountType,
                discountPrice: itemBillInput.itemDiscount,
                productWastage: itemBillInput.itemWastage,
                productLabour: itemBillInput.itemLabour,
                productHsnCode: itemBillInput.itemHsnCode,
                productTaxType: itemBillInput.itemTaxType,
                productTax: itemBillInput.itemLevelTax,
                taxId: itemBillInput.taxId,
                productEANCode: itemBillInput.itemEANCode,
                taxIncExc: itemBillInput.taxIncExc,
                imei1: itemBillInput.imei1,
                imei2: itemBillInput.imei2,
                count: itemBillInput.itemQuantity,
                purchasePrice: itemBillInput.itemPurchasePrice,
                isExist: false,
              };
              if (addedProducts.length !== 0) {
                const newItem = JSON.stringify(product);
                const products = addedProducts.map(
                  ({
                    productName,
                    isExist,
                    purchasePrice,
                    count,
                    imei2,
                    taxIncExc,
                    productEANCode,
                    taxId,
                    productTax,
                    productTaxType,
                    productPrice,
                    productMrp,
                    unitOfMeasurment,
                    discountType,
                    discountPrice,
                    productWastage,
                    productLabour,
                    productHsnCode,
                  }) => {
                    return JSON.stringify({
                      productName,
                      isExist,
                      purchasePrice,
                      count,
                      imei2,
                      taxIncExc,
                      productEANCode,
                      taxId,
                      productTax,
                      productTaxType,
                      productPrice,
                      productMrp,
                      unitOfMeasurment,
                      discountType,
                      discountPrice,
                      productWastage,
                      productLabour,
                      productHsnCode,
                    });
                  }
                );
                const isExist = products.includes(`{${newItem}}`);

                if (isExist) {
                  return alert("Product already exist");
                }
              }
              formValidation(
                {
                  productId: uuidv4(),
                  ...product,
                },
                "fromDec"
              );
              setToInitialState();
            }}
          >
            ADD ITEM
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        scrollable={true}
        show={offersModal}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setOffersModal(false);
          setPromoCode("");
        }}
        style={{ padding: 0, margin: 0 }}
      >
        <Modal.Header>
          <div>
            <button
              className="closebutton"
              onClick={() => {
                setOffersModal(false);
                setPromoCode("");
              }}
            >
              <CancelIcon />
            </button>
            <div
              className="couponheading"
              style={{ marginTop: 20, marginBottom: 5 }}
            >
              <div>
                <LocalOfferIcon style={{ fontSize: 20 }} />
              </div>
              <h3>Apply Coupons</h3>
            </div>
            <div>
              <TextField
                className="couponInput"
                placeholder="Enter your code"
                onChange={(e) => setPromoCode(e.target.value)}
                value={promoCode}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <button
                        className="couponInputBtn"
                        disabled={couponArr.length === 0 ? true : false}
                      >
                        Search
                      </button>
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
              />
            </div>
          </div>
        </Modal.Header>
        <Modal.Body
          style={{
            background: "#f5f9fc",
            maxHeight: "calc(100vh - 210px)",
            overflowY: "auto",
          }}
        >
          {couponArr.length > 0 ? (
            <>
              {couponArr.map((data) => (
                <div key={data.couponId} className="cardContainer">
                  <div className="cardDataContainer">
                    <div className="couponCodeStyle">
                      <p>{data.promocode}</p>
                    </div>
                    <div className="coupounHeading">
                      <p>Get</p>
                    </div>
                    {data.discountType === "flat" ? (
                      <div className="couponOfferText">
                        <p>
                          {country.CurrencySymbol}
                          {data.discountAmount} OFF
                        </p>
                      </div>
                    ) : (
                      <div className="couponOfferText">
                        <p>{data.discountAmount}% OFF</p>
                      </div>
                    )}
                    <div className="applyAndButton">
                      <div className="applyTextStyle">
                        <p className="couponApplyPurchase">
                          Apply on purchase worth{" "}
                          {currencyFormatter(data.condition.minPrice)} or more
                        </p>
                        <p className="couponApplyValid">
                          Valid from{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {new Date(data.startDate).getDate() +
                              " " +
                              month[new Date(data.startDate).getMonth()].short +
                              " " +
                              new Date(data.startDate).getFullYear()}
                          </span>{" "}
                          to{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {new Date(data.expiryDate).getDate() +
                              " " +
                              month[new Date(data.expiryDate).getMonth()]
                                .short +
                              " " +
                              new Date(data.expiryDate).getFullYear()}
                          </span>
                        </p>
                      </div>
                      <div className="applyBtnStyle">
                        {Object.keys(appliedCoupon).length > 0 &&
                        appliedCoupon.couponId === data.couponId ? (
                          <button
                            className="couponApplyBtn"
                            onClick={() => {
                              setAppliedCoupon({});
                            }}
                          >
                            Remove
                          </button>
                        ) : (
                          <button
                            className="couponApplyBtn"
                            onClick={() => couponValidator(data)}
                          >
                            Apply
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="couponSaveCoupon">
                      <p>
                        You will save
                        {data.discountType === "flat" ? (
                          <> {currencyFormatter(data.discountAmount)}</>
                        ) : (
                          <> {data.discountAmount}%</>
                        )}{" "}
                        with this coupon
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div
              className="cardContainer"
              style={{ textAlign: "center", marginTop: "20px", opacity: "0.5" }}
            >
              <p>No Coupons To Show</p>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        scrollable={true}
        show={loyaltyModal}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setLoyaltyModal(false);
        }}
        style={{ padding: 0, margin: 0 }}
      >
        <Modal.Header>
          <div>
            <button
              className="closebutton"
              onClick={() => {
                setLoyaltyModal(false);
              }}
            >
              <CancelIcon />
            </button>
            <div
              className="couponheading"
              style={{ marginTop: 20, marginBottom: 5 }}
            >
              <div>
                <Loyalty style={{ fontSize: 20 }} />
              </div>
              <h3>Avilable Loyalty Coupons</h3>
            </div>
            {/* <div>
              <TextField
                className="couponInput"
                placeholder="Enter your code"
                onChange={(e) => setPromoCode(e.target.value)}
                value={promoCode}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <button
                        className="couponInputBtn"
                        disabled={couponArr.length === 0 ? true : false}
                      >
                        Search
                      </button>
                    </InputAdornment>
                  ),
                }}
                variant="outlined"
              />
            </div> */}
          </div>
        </Modal.Header>
        <Modal.Body
          style={{
            background: "#f5f9fc",
            maxHeight: "calc(100vh - 210px)",
            overflowY: "auto",
          }}
        >
          {loyaltyArr.length > 0 ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                flexWrap: "wrap",
                margin: "20px",
              }}
            >
              {loyaltyArr.map((data) => (
                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    border: "1px solid rgb(214, 214, 214)",
                    borderRadius: "5px",
                    boxShadow: "3px 3px 5px 1px rgb(231, 231, 231)",
                    marginBottom: "20px",
                    marginRight: "10px",
                    marginLeft: "20px",
                  }}
                  key={data.couponId}
                >
                  <div
                    className="inCardStyle"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "30%",
                        textAlign: "center",
                        fontSize: "14px",
                        backgroundColor: "#0dcaf0",
                        paddingTop: "5px",
                        color: "white",
                        borderRadius: "5px 0px 0px 5px",
                        margin: "5px",
                      }}
                    >
                      USE {data.minLoyaltyPointsReq} LOYALTY POINTS
                    </div>
                    <div
                      style={{
                        height: "85px",
                        border: "2px dotted black",
                      }}
                    ></div>
                    <div style={{ width: "70%", margin: "5px" }}>
                      <p>{data.couponDetails}</p>
                      <Button
                        disabled={
                          parseFloat(data.minLoyaltyPointsReq) >
                          parseFloat(loyaltyPoints)
                            ? true
                            : false
                        }
                        variant="outline-info"
                        size="sm"
                        style={{
                          marginTop: "-15px",
                          float: "right",
                          marginBottom: "20px",
                        }}
                        onClick={() => {
                          setAppliedLoyalty(data);
                          setLoyaltyModal(false);
                        }}
                      >
                        Redeem
                      </Button>
                    </div>
                  </div>
                  <div></div>
                </div>
              ))}
            </div>
          ) : (
            <div
              className="cardContainer"
              style={{ textAlign: "center", marginTop: "20px", opacity: "0.5" }}
            >
              <p>No Coupons To Show</p>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={settingModal}
        dialogClassName="custom-modal"
        onHide={() => setSettingModal(false)}
      >
        <Modal.Header>
          <div>
            <div style={{ float: "left" }}>
              <h3>Additional settings</h3>
            </div>
            <div
              style={{
                float: "right",
                position: "absolute",
                left: "70%",
              }}
            >
              <div style={{ float: "left" }}>
                <p>Printer Type: </p>
              </div>
              <div style={{ float: "right" }}>
                <div style={{ float: "left", marginLeft: "10px" }}>
                  {" "}
                  {/* <input
                    type="radio"
                    name="printerType"
                    value="Thermal"
                    checked={billLineSettings.printerType === "Thermal"}
                    onChange={(e) => {
                      setBillLineSettings({
                        ...billLineSettings,
                        printerType: e.target.value,
                      });
                    }}
                  />{" "} */}
                  <label>Thermal</label>{" "}
                </div>
                {/* <div style={{ float: "left", marginLeft: "20px" }}>
                  {" "}
                  <input
                    type="radio"
                    name="printerType"
                    value="A4"
                    checked={billLineSettings.printerType === "A4"}
                    title="a4"
                    onChange={(e) => {
                      setBillLineSettings({
                        ...billLineSettings,
                        printerType: e.target.value,
                      });
                    }}
                  />{" "}
                  <label>A4</label>
                </div> */}
              </div>
            </div>
            {billLineSettings.printerType === "Thermal" && (
              <div
                style={{
                  float: "right",
                  position: "absolute",
                  left: "70%",
                  marginTop: "30px",
                }}
              >
                <div style={{ float: "left" }}>
                  <p>Paper Size: </p>
                </div>{" "}
                <div style={{ float: "right" }}>
                  <div style={{ float: "left", marginLeft: "10px" }}>
                    <input
                      type="radio"
                      name="thermalPaperSize"
                      value="55"
                      checked={billLineSettings.thermalPaperSize === "55"}
                      onChange={(e) => {
                        setBillLineSettings({
                          ...billLineSettings,
                          thermalPaperSize: e.target.value,
                        });
                      }}
                    />{" "}
                    <label>55mm</label>
                  </div>
                  <div style={{ float: "left", marginLeft: "20px" }}>
                    <input
                      type="radio"
                      name="thermalPaperSize"
                      value="80"
                      checked={billLineSettings.thermalPaperSize === "80"}
                      onChange={(e) => {
                        setBillLineSettings({
                          ...billLineSettings,
                          thermalPaperSize: e.target.value,
                        });
                      }}
                    />{" "}
                    <label>80mm</label>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body">
            <div className="modal-content">
              <div
                style={{
                  margin: "10px 0px 0px 15px",
                }}
              >
                <h2>Bill Settings</h2>
              </div>
              <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Add Discount</label>
                  <br />
                  <small className="text-muted">
                    Discount will be applied on the sub total.
                  </small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.discount}
                    onChange={checkBoxHandler}
                    value="discount"
                    id="discount"
                  />
                </div>
              </div>
              {/* <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Add Tax</label>
                  <br />
                  <small className="text-muted">
                    Tax will be applied on the discounted sub total.
                  </small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.tax}
                    onChange={checkBoxHandler}
                    value="tax"
                  />
                </div>
              </div> */}
              {/* <div style={{ borderBottom: "2px solid black" }}>
                  <div style={{ margin: "15px", float: "left" }}>
                    <label>Reedem Points</label>
                    <br />
                    <small className="text-muted">
                      Loyalty points will be reedemed on the bill.
                    </small>
                  </div>
                  <div>
                    <Checkbox
                      style={{ float: "right", margin: "15px" }}
                      checked={billLineSettings.reedemPoints}
                      onChange={checkBoxHandler}
                      value="reedemPoints"
                    />
                  </div>
                </div> */}
              {/* <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Round Off</label>
                  <br />
                  <small className="text-muted">
                    Round Off the amount to near by whole number.
                  </small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.roundOff}
                    onChange={checkBoxHandler}
                    value="roundOff"
                  />
                </div>
              </div>
              <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Paid Amount</label>
                  <br />
                  <small className="text-muted">Total amount user paid.</small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.paidAmount}
                    onChange={checkBoxHandler}
                    value="paidAmount"
                  />
                </div>
              </div> */}
              {/* <div style={{ borderBottom: "2px solid black" }}>
                  <div style={{ margin: "15px", float: "left" }}>
                    <label>Prepaid Amount</label>
                    <br />
                    <small className="text-muted">
                      The total amount that is prepaid.
                    </small>
                  </div>
                  <div>
                    <Checkbox
                      style={{ float: "right", margin: "15px" }}
                      checked={billLineSettings.prepaidAmount}
                      onChange={checkBoxHandler}
                      value="prepaidAmount"
                    />
                  </div>
                </div> */}
              <div
                style={{
                  borderBottom: "2px solid black",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* <div>
                  <div style={{ margin: "15px", float: "left" }}>
                    <label>Other charges</label>
                    <br />
                    <small className="text-muted">
                      Create your own custom charges
                    </small>
                  </div>
                  <div>
                    <Checkbox
                      style={{ float: "right", margin: "15px" }}
                      checked={invoiceSettings.othercharges}
                      onChange={checkBoxHandler}
                      value="otherCharges"
                    />
                  </div>
                </div> */}
                {/* {invoiceSettings.othercharges && (
                  <div style={{ marginLeft: "15px", float: "right" }}>
                    <p
                      style={{
                        fontSize: "13px",
                        color: "#ef4667",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setAddExtraChargeField(!addExtraChargeField)
                      }
                    >
                      Click here to create custom charges.#
                    </p>
                    {addExtraChargeField && (
                      <div style={{ marginBottom: "10px" }}>
                        <input
                          placeholder="Enter charge name"
                          onChange={(e) => setChargesName(e.target.value)}
                          value={chargesName}
                        />
                        <Button
                          style={{ marginLeft: "3%", marginTop: -3 }}
                          size="sm"
                          onClick={() => {
                            if (chargesName === "") {
                              alert("Field should not be empty");
                              return;
                            }
                            chargesAddButtonHandler();
                          }}
                        >
                          Add
                        </Button>
                      </div>
                    )}
                    {billLineSettings.otherChargesField.map((data) => (
                      <div
                        key={data.id}
                        style={{
                          padding: "8px",
                          float: "left",
                          display: "flex",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          style={{
                            border: "2px solid black",
                            padding: "2px 10px 2px 10px",
                            borderRadius: "17px",
                          }}
                        >
                          <label>{data.name}</label>
                          <HighlightOffIcon
                            style={{
                              marginLeft: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => deleteChargeHandler(data.id)}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )} */}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{ borderBottom: "2px solid black", padding: "15px" }}
                >
                  <div style={{ float: "left" }}>
                    <label
                      style={{
                        margin: 0,
                      }}
                    >
                      Delivery Address
                    </label>
                  </div>
                  <div>
                    <Checkbox
                      style={{ float: "right" }}
                      checked={billLineSettings.hasDeliveryAddress}
                      onChange={checkBoxHandler}
                      value="hasDeliveryAddress"
                    />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* <div
                  style={{ borderBottom: "2px solid black", padding: "15px" }}
                >
                  <div style={{ float: "left" }}>
                    <label
                      style={{
                        margin: 0,
                      }}
                    >
                      Block Number
                    </label>
                  </div>
                  <div>
                    <Checkbox
                      style={{ float: "right" }}
                      checked={billLineSettings.hasBlockNo}
                      onChange={checkBoxHandler}
                      value="hasBlockNo"
                    />
                  </div>
                </div> */}
              </div>
              {/* <div style={{ borderBottom: "2px solid black" }}>
                  <div style={{ margin: "15px", float: "left" }}>
                    <label>Apply coupon</label>
                    <br />
                    <small className="text-muted">
                      Apply coupon code if any.
                    </small>
                  </div>
                  <div>
                    <Checkbox
                      style={{ float: "right", margin: "15px" }}
                      checked={billLineSettings.coupon}
                      onChange={checkBoxHandler}
                      value="coupon"
                    />
                  </div>
                </div> */}
            </div>
            <div className="modal-content">
              <div
                style={{
                  margin: "10px 0px 0px 15px",
                }}
              >
                <h2>Line Item Settings</h2>
              </div>
              <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Item MRP</label>
                  <br />
                  <small className="text-muted">Add MRP of the product.</small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.itemMRP}
                    onChange={checkBoxHandler}
                    value="itemMRP"
                  />
                </div>
              </div>
              <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Item Discount</label>
                  <br />
                  <small className="text-muted">
                    Discount will be added to the product level.
                  </small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.itemDiscount}
                    onChange={checkBoxHandler}
                    value="itemDiscount"
                  />
                </div>
              </div>
              {/* <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Wastage</label>
                  <br />
                  <small className="text-muted">
                    Wastage will be added for Item.
                  </small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.itemWastage}
                    onChange={checkBoxHandler}
                    value="itemWastage"
                  />
                </div>
              </div> */}
              {/* <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Labour</label>
                  <br />
                  <small className="text-muted">
                    Labour will be added for Item level.
                  </small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.itemLabour}
                    onChange={checkBoxHandler}
                    value="itemLabour"
                  />
                </div>
              </div> */}
              <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>HSN Code</label>
                  <br />
                  <small className="text-muted">
                    Add HSN code of the product if available.
                  </small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.hsnCode}
                    onChange={checkBoxHandler}
                    value="hsnCode"
                  />
                </div>
              </div>
              <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Item Level Taxes</label>
                  <br />
                  <small className="text-muted">
                    Apply Tax for separate Items
                  </small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.itemLevelTax}
                    onChange={checkBoxHandler}
                    value="itemLevelTax"
                  />
                </div>
              </div>
              <div>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>IMEI1/IMEI2</label>
                  <br />
                  <small className="text-muted">
                    Add IMEI number of the product
                  </small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.imei}
                    onChange={checkBoxHandler}
                    value="imei"
                  />
                </div>
              </div>
            </div>
            <div className="modal-content">
              <div
                style={{
                  margin: "10px 0px 0px 15px",
                }}
              >
                <h2>Invoice Settings</h2>
              </div>
              {/* <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Billing Address</label>
                  <br />
                  <small className="text-muted">
                    Add the address of the person to whom it is billed.
                  </small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.billingAddress}
                    onChange={checkBoxHandler}
                    value="billingAddress"
                  />
                </div>
              </div>
              <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Shipping Address</label>
                  <br />
                  <small className="text-muted">
                    Add the address of the person where it is shipped.
                  </small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.shippingAddress}
                    onChange={checkBoxHandler}
                    value="shippingAddress"
                  />
                </div>
              </div> */}
              <div
                style={{
                  borderBottom: "2px solid black",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div>
                  <div style={{ margin: "15px", float: "left" }}>
                    <label>Terms and Conditions</label>
                    <br />
                    <small className="text-muted">
                      Add your terms and conditions(displayed in invoice)
                    </small>
                  </div>
                  <div>
                    <Checkbox
                      style={{ float: "right", margin: "15px" }}
                      checked={billLineSettings.termsAndCondition}
                      onChange={checkBoxHandler}
                      value="termsAndCondition"
                    />
                  </div>
                </div>
                {billLineSettings.termsAndCondition && (
                  <div style={{ marginLeft: "15px", float: "right" }}>
                    <p
                      style={{
                        fontSize: "13px",
                        color: "red",
                        cursor: "pointer",
                      }}
                      onClick={() => setaddTermsField(!addTermsField)}
                    >
                      Click here to add or edit Terms and conditions.
                    </p>
                    {addTermsField && (
                      <div>
                        <TextareaAutosize
                          style={{ width: "300px" }}
                          rowsMin={3}
                          placeholder="Enter terms and condition"
                          value={billLineSettings.tAndCField}
                          onChange={(e) =>
                            setBillLineSettings({
                              ...billLineSettings,
                              tAndCField: e.target.value,
                            })
                          }
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div
                style={{
                  borderBottom: "2px solid black",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div>
                  <div style={{ margin: "15px", float: "left" }}>
                    <label>Payment Terms and Conditions</label>
                    <br />
                    <small className="text-muted">
                      Add your payment terms and conditions(displayed in
                      invoice).
                    </small>
                  </div>
                  <div>
                    <Checkbox
                      style={{ float: "right", margin: "15px" }}
                      checked={billLineSettings.paymentTerms}
                      onChange={checkBoxHandler}
                      value="paymentTerms"
                    />
                  </div>
                </div>
                {billLineSettings.paymentTerms && (
                  <div style={{ marginLeft: "15px", float: "right" }}>
                    <p
                      style={{
                        fontSize: "13px",
                        color: "red",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setAddPaymentTermsField(!addPaymentTermsField)
                      }
                    >
                      Click here to add or edit Payment Terms.
                    </p>
                    {addPaymentTermsField && (
                      <div>
                        <TextareaAutosize
                          style={{ width: "300px" }}
                          rowsMin={3}
                          placeholder="Enter Payment terms"
                          value={billLineSettings.paymentTermsField}
                          onChange={(e) =>
                            setBillLineSettings({
                              ...billLineSettings,
                              paymentTermsField: e.target.value,
                            })
                          }
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
              {/* <div style={{ borderBottom: "2px solid black" }}>
                  <div style={{ margin: "15px", float: "left" }}>
                    <label>Due Date</label>
                    <br />
                    <small className="text-muted">
                      Add the due date for bill payment.
                    </small>
                  </div>
                  <div>
                    <Checkbox
                      style={{ float: "right", margin: "15px" }}
                      checked={billLineSettings.dueDate}
                      onChange={checkBoxHandler}
                      value="dueDate"
                    />
                  </div>
                </div> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div>
                  <div style={{ margin: "15px", float: "left" }}>
                    <label>Invoice Prefix/Suffix</label>
                    <br />
                    <small className="text-muted">
                      Add Invoice Prefix and Suffix.
                    </small>
                  </div>
                  <div>
                    <Checkbox
                      style={{ float: "right", margin: "15px" }}
                      checked={billLineSettings.invoicePrefix}
                      value="invoicePrefix"
                    />
                  </div>
                </div>
                {billLineSettings.invoicePrefix && (
                  <div style={{ marginLeft: "15px", float: "right" }}>
                    <p
                      style={{
                        fontSize: "13px",
                        color: "red",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setAddInvoicePrefixField(!addInvoicePrefixField)
                      }
                    >
                      Click here to add or edit Invoice prefix and suffix.
                    </p>
                    {addInvoicePrefixField && (
                      <div>
                        <input
                          type="text"
                          style={{ width: "300px" }}
                          placeholder="Enter invoice prefix(eg GHK)"
                          value={billLineSettings.invoicePrefixField}
                          onChange={(e) =>
                            setBillLineSettings({
                              ...billLineSettings,
                              invoicePrefixField: e.target.value,
                            })
                          }
                        />
                        <input
                          type="number"
                          style={{ width: "300px" }}
                          placeholder="Enter invoice suffix(eg 0001)"
                          value={billLineSettings.currentInvoiceNumber}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => {
                            setBillLineSettings((prev) => ({
                              ...prev,
                              invoiceSuffixField: e.target.value,
                              currentInvoiceNumber: e.target.value,
                            }));
                            setItemBillResult({
                              ...itemBillResult,
                              invoiceNumber: e.target.value,
                            });
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
              {/* <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Employee name</label>
                  <br />
                  <small className="text-muted">
                    Choose employee who is billing
                  </small>
                  <br />
                  {employeeArr.length === 0 && (
                    <>
                      <small style={{ color: "red" }}>
                        Please add your shop employees
                      </small>
                      <small style={{ color: "red" }}>
                        {" "}
                        in Ghoshak business app
                      </small>
                    </>
                  )}
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={
                      employeeArr.length === 0
                        ? false
                        : billLineSettings.employee
                    }
                    onChange={checkBoxHandler}
                    value="employee"
                    disabled={employeeArr.length === 0 ? true : false}
                  />
                </div>
              </div> */}
              {/* <div style={{ borderBottom: "2px solid black" }}>
                <div style={{ margin: "15px", float: "left" }}>
                  <label>Mode of Payment</label>
                  <br />
                  <small className="text-muted">
                    Choose mode of payment while billing
                  </small>
                </div>
                <div>
                  <Checkbox
                    style={{ float: "right", margin: "15px" }}
                    checked={billLineSettings.modeOfPayment}
                    onChange={checkBoxHandler}
                    value="modeOfPayment"
                  />
                </div>
              </div> */}
              {/* <div style={{ borderBottom: "2px solid black" }}>
                  <div style={{ margin: "15px", float: "left" }}>
                    <label>Add remainder</label>
                    <br />
                    <small className="text-muted">
                      Add reminder to the customer about their purchase
                    </small>
                  </div>
                  <div>
                    <Checkbox
                      style={{ float: "right", margin: "15px" }}
                      checked={billLineSettings.addRemainder}
                      onChange={checkBoxHandler}
                      value="addRemainder"
                    />
                  </div>
                </div> */}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button 

          // ref={saveOthercharges}
          // style={{display:"none"}}
            onClick={() => {
              if (billLineSettings.gst === "") {
                return alert("Please enter GST");
              } else if (billLineSettings.igst === "") {
                return alert("Please select IGST");
              } else if (billLineSettings.cess === "") {
                return alert("Please select CESS");
              } else if (billLineSettings.additionalcess === "") {
                return alert("Please select Additional CESS");
              }
              setSettingModal(false);
              updateSettings().then((data) => {
                setBillLineSettings(data.Attributes.settings);
                dispatch({
                  type: "SET_SETTINGS",
                  payload: data.Attributes.settings,
                });
              });
             
            }}
          >
            Save
          </Button> */}
        </Modal.Footer>
      </Modal>

      <Modal
        show={invoicePage}
        style={{ width: "90%", marginLeft: "5%" }}
        dialogClassName="custom-modal"
        onHide={() => setinvoicePage(false)}
        ref={alertMsg}
      >
        <div className="modal-content" style={{ position: "absolute" }}>
          <Modal.Header closeButton>
            <h3 style={{ color: "#EF4667" }}>
              {isAdvanceSetting ? "Advance Settings" : "Invoice Customization"}
            </h3>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                width: "100%",
                maxWidth: "-webkit-fill-available",
                maxWidth: "-moz-available",
                maxWidth: "fill-available",
                backgroundColor: "#F5F9FC",
              }}
            >
              <Invoice
                mode={isAdvanceSetting ? "advance" : "bill"}
                ref={alertMsg}
                onHide={(v) => setinvoicePage(v)}
              />
            </div>
          </Modal.Body>
        </div>
      </Modal>

      {!loading && !counterId && (
        <StartCounterModal
          open={starterCounterModal}
          setOpen={setStarterCounterModal}
          setCounterId={setCounterId}
        />
      )}
      {/* <Steps
        enabled={enabled}
        steps={steps}
        initialStep={initialStep}
        onExit={onExit}
      /> */}
    </Container>
  );
};
export default Billing;

// <div className="">
// <h2>Input Setting</h2>
// <div
//   style={{
//     display: "flex",
//     alignItem: "center",
//     gap: "0.5rem",
//     marginLeft: "24px",
//   }}
// >
//   <Checkbox
//     onClick={(e) => updateSettings(e)}
//     checked={customization.uniqueIdentity}
//     name="uniqueIdentity"
//   />
//   <div>
//     Alias{" "}
//     <span
//       style={{
//         fontSize: 14,
//       }}
//     >
//       (Flat no or Block no)
//     </span>
//   </div>
// </div>
// </div>
